import {
  AfterViewInit,
  Component,
  OnChanges,
  OnInit,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { delay, last } from 'rxjs/operators';
import { AvtDialogDeleteComponent } from 'src/app/avt-dialog-delete/avt-dialog-delete.component';
import { ListeComponent } from 'src/app/liste/liste.component';
import { RechercheComponent } from 'src/app/recherche/recherche.component';
import { DateService } from 'src/app/services/date.service';
import { GeneralService } from 'src/app/services/general.service';

import { FormControl, FormGroup } from '@angular/forms';
import { lastIndexOf, lowerFirst } from 'lodash';
import { threadId } from 'worker_threads';
import { runInThisContext } from 'vm';
import { LoginComponent } from '@unilog/template/lib/shared/users/login/login.component';
import { Console } from 'console';
import { ThrowStmt } from '@angular/compiler';
import { element } from 'protractor';
import { BraquetService } from '../braquet/braquet.service';
import { TarifService } from '../tarif-reservation/tarif.service';

interface TypeTravel {
  value: string;
  viewValue: string;
}
interface Saison {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-hotel-reservation',
  templateUrl: './hotel-reservation.component.html',
  styleUrls: ['./hotel-reservation.component.scss'],
})
export class HotelReservationComponent implements OnInit, OnChanges {
  Typtrav: TypeTravel[] = [
    { value: 'ponctuel', viewValue: 'Ponctuel' },
    { value: 'serie', viewValue: 'Serie' },
  ];

  saisons: Saison[] = [
    { value: 'winter', viewValue: 'Winter' },
    { value: 'summer', viewValue: 'Summer' },
  ];

  typControl = new FormControl();
  saisonControl = new FormControl();
  form = new FormGroup({
    typtra: this.typControl,
    sais: this.saisonControl,
  });

  TableImpressionPreview = [] as any;
  constructor(
    public generalService: GeneralService,
    private dateService: DateService,
    public route: ActivatedRoute,
    public router: Router,
    private braquetService: BraquetService,
    private tarifService: TarifService
  ) {
    this.router.events.subscribe((val: any) => {
      this.route.params.subscribe((params) => {
        this.travelCode = params['param'];
        this.mode = params['mode'];

        if (val.url && val.url != this.lastUrl && this.travelCode == -1) {
          this.reservation = {};
          this.reservationD = {};
          this.exist = true;
          this.dsReservation = null;
          this.listeReservationDetail = [];
          this.lastUrl = val.url;
        }
      });
    });

    //call Liste Devise
    this.generalService.rechercheTable2('API_ListeDevise').subscribe((res) => {
      this.TabDevise = res;
      // console.log(this.TabDevise);
      this.TabDevise.forEach((element) => {
        this.ListeDevise.push(element.Devise_Code);
        this.ListeSymbolDevive.push({
          DevCde: element.Devise_Code,
          DevSymb: element.Devise_Symbole,
        });
      });
      // console.log(this.ListeDevise);
    });
  }

  @ViewChild('villeComponent')
  villeComponent: RechercheComponent;
  @ViewChild('fournisseurComponent')
  public fournisseurComponent: RechercheComponent;
  @ViewChild('clientComponent')
  public clientComponent: RechercheComponent;

  // public villeComponent: RechercheComponent;
  @ViewChildren(ListeComponent)
  public listeConmponent: QueryList<ListeComponent>;
  exist: boolean = false;
  ChangeHdeb = false;
  ListeDevise = [];
  ListeSymbolDevive = [];
  TabDevise;
  EventCalculated;
  dsReservation;
  dsReservationInit;
  refreshing = false;
  reservation;
  reservationD;
  listeReservationDetail = [];
  lastUrl;
  titre = '';
  travelCode;
  totalSupp = 0;
  totalCollective = 0;
  totalIndividuel = 0;
  travelPrices: any = [];
  eventPrices: any = null;
  mode;
  listeEvennementFiltred = [];
  listeTypeFiltred;
  tarificationEvennement = this.generalService.tarificationEvennement;
  listeTypeEvennement; //= this.generalService.listeTypeEvennement;
  listeEvennement; // = this.generalService.listeEvennement;
  listeVille = this.generalService.listeVille;
  filterdVille = this.generalService.listeVille;
  listeType; //= this.generalService.listeType;
  tarificationSelectedEvennement = [];
  detailJourCout;
  detailJourCoutSupp;
  time = [];
  myNewList = [];
  pageTitle = '';
  filterdTime = [];
  lastOpened = null;
  ableToChange = true;
  selectedEvent = null;
  saveTimeout: any;
  columns = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'typeEvennementText',
        Lg_Code: '',
        TableRD_Des: 'PRESTATION',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'TravelD_Event',
        Lg_Code: '',
        TableRD_Des: 'TYPE DE PRESTATION',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'TravelD_Ville',
        Lg_Code: '',
        TableRD_Des: 'VILLE',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Tiers_RS',
        Lg_Code: '',
        TableRD_Des: 'FOURNISSEUR',
        TableRD_Largeur: 120,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'typeText',
        Lg_Code: '',
        TableRD_Des: 'TYPE',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'TravelD_Obs',
        Lg_Code: '',
        TableRD_Des: 'OBSERVATION',
        TableRD_Largeur: 120,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },

      {
        TableRE_Code: '',
        TableRD_Champs: 'TravelD_HDeb',
        Lg_Code: '',
        TableRD_Des: 'H.Début',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 1,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'TravelD_DureeTrajet',
        Lg_Code: '',
        TableRD_Des: 'Durée du transport',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'TravelD_Duree',
        Lg_Code: '',
        TableRD_Des: 'Durée',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'TravelD_HFin',
        Lg_Code: '',
        TableRD_Des: 'H.Fin',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 2,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },

      {
        TableRE_Code: '',
        TableRD_Champs: 'TravelD_Km',
        Lg_Code: '',
        TableRD_Des: 'Kilometrage',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'TravelD_NbreVoiture',
        Lg_Code: '',
        TableRD_Des: 'Nombre des voitures',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };

  columnsLigne0 = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'typeEvennementText',
        Lg_Code: '',
        TableRD_Des: 'PRESTATION',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'TravelD_Event',
        Lg_Code: '',
        TableRD_Des: 'TYPE DE PRESTATION',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'TravelD_Ville',
        Lg_Code: '',
        TableRD_Des: 'VILLE',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Tiers_RS',
        Lg_Code: '',
        TableRD_Des: 'FOURNISSEUR',
        TableRD_Largeur: 120,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'typeText',
        Lg_Code: '',
        TableRD_Des: 'TYPE',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'TravelD_Obs',
        Lg_Code: '',
        TableRD_Des: 'OBSERVATION',
        TableRD_Largeur: 120,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'TravelD_DureeTrajet',
        Lg_Code: '',
        TableRD_Des: 'Durée du transport',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'TravelD_Km',
        Lg_Code: '',
        TableRD_Des: 'Kilometrage',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'TravelD_NbreVoiture',
        Lg_Code: '',
        TableRD_Des: 'Nombre des voitures',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };

  listBtnOnlyEdit = [
    {
      name: 'Info',
      class: 'colorBlueInfo',
      text: 'Info',
      icon: 'info_outline',
    },
    {
      name: 'RH',
      class: 'colorBlueInfo',
      text: 'réglage horaire',
      icon: 'restore',
    },
  ];

  listBtn: Array<any> = [
    {
      name: 'RH',
      class: 'colorBlueInfo',
      text: 'réglage horaire',
      icon: 'restore',
    },

    {
      name: 'Info',
      class: 'colorBlueInfo',
      text: 'Info',
      icon: 'info_outline',
    },
    {
      name: 'descendre',
      class: 'colorGreen',
      text: 'Descendre',
      icon: 'arrow_downward',
    },
    {
      name: 'monter',
      class: 'colorGreen',
      text: 'Monter',
      icon: 'arrow_upward',
    },
    { name: 'ajouter', class: 'colorGreen', text: 'Ajouter', icon: 'add' },
    { name: 'supprimer', class: 'colorRed', text: 'Supprimer', icon: 'delete' },
  ];
  @ViewChild('frmAjout', { static: false }) frmAjout;
  @ViewChild('frmDetai', { static: false }) frmDetai;
  @ViewChild('tableLineDetail', { static: false }) tableLineDetail;
  @ViewChild('frmDetaiSupp', { static: false }) frmDetaiSupp;
  @ViewChild('frmCalcul', { static: false }) frmCalcul;
  @ViewChild('frmAlertDup', { static: false }) frmAlertDup;
  @ViewChild('frmInfo', { static: false }) frmInfo;
  @ViewChild('frmImport', { static: false }) frmImport;
  @ViewChild('frmMenuTarif', { static: false }) frmMenuTarif;
  @ViewChild('frmDetailCalcul', { static: false }) frmDetailCalcul;
  @ViewChild('frmVerifyError', { static: false }) frmVerifyError;
  @ViewChild('frmImpressionPreview', { static: false }) frmImpressionPreview;

  index: number;
  totalGlobal: any = {};
  totalSingle: any = {};
  totalSupplement: any = {};
  disabled = false;
  TravelD_Jour;
  bouton;
  listeOpend;
  travelIsCalculated = false;
  initCircuit = [];
  pos = 0;
  TauxMarge;
  braquetResult;
  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if ('mode' in params) {
        this.standardMode = params['mode'] === 'model';
        this.pageTitle = 'Modèle';
      } else {
        this.standardMode = false; // Default to circuit if no mode param
      }
      console.log(
        'Navigated with mode:',
        params['mode'] || 'circuit (default)'
      );
    });
    this.initEverything();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['standardMode']) {
      console.log('standardMode changed:', this.standardMode);
      if (this.standardMode) {
        this.pageTitle = 'Modèle';
      } else this.pageTitle = 'Circuit';
    }
    if (changes['indexJour']) {
      console.log('indexJour changed:', this.indexJour);
      this.ableToChange = true;
    }
  }
  initEverything() {
    var d: Date = new Date('2000-01-01 00:00');
    for (var i = 0; i < 1440; i++) {
      this.time.push(
        this.dateService.setFormaTime(d.getHours() + ':' + d.getMinutes())
      );
      d.setMinutes(d.getMinutes() + 2);
    }
    this.reservation = {};
    this.reservationD = {};
    this.filterdTime = this.time.slice();
    this.readParamUrl();
    this.setUpGlobalValues();
    this.refreshList();

    this.route.queryParams.subscribe((params) => {
      if (params['braquet']) {
        console.log(params['braquet']);
        console.log(this.braquetService.getSharedBraquetMatrixResult());
        const findObjectByCode = (matrix, code) =>
          matrix.flat().find((obj) => obj.code === code);
        this.braquetResult = findObjectByCode(
          this.braquetService.getSharedBraquetMatrixResult(),
          params['braquet']
        );
      }
    });
    this.router.events.subscribe((event) => {
      if (
        event instanceof NavigationStart &&
        event.navigationTrigger === 'popstate'
      ) {
        // 'popstate' indicates a back or forward navigation
        this.refreshPage();
      }
    });
  }

  refreshPage(): void {
    // Refresh the page or reload data as needed
    console.log('Refreshing page...');

    window.location.reload(); // This will fully reload the page
    // Alternatively, you could reload data specific to the component without a full page reload
  }

  async handleModificationCircuitByCodeBraquet(braquetResult) {
    if (this.dsReservation) {
      this.dsReservation.Travel[0].Travel_NbPerso = braquetResult.nbpersonne; // Set nbPersonne
      this.dsReservation.Travel[0].Travel_DateDeb = braquetResult.startDate;
      this.dsReservation.Travel[0].Travel_DateFin = braquetResult.endDate;
      this.dsReservation.Travel[0].Travel_statut1 = 0;
      this.dsReservation.TravelDM = [];
      try {
        await this.generalService
          .enregisterTable(this.dsReservation)
          .toPromise();

        setTimeout(() => {
          this.calculAll(this.braquetResult);
        }, 500);
      } catch (error) {
        console.error(error);
      }
    }
  }

  remove(list, value) {
    list.splice(list.indexOf(value), 1);
  }

  suppListfromlist(List, listsupp) {
    listsupp.forEach((e1) => {
      if (List.find((e2) => e2 == e1)) {
        this.remove(List, e1);
        this.generalService.delete(e1.id, 'TravelDM').subscribe((res) => {
          console.log('supp');
        });
      }
    });
    return List;
  }
  fetchDsReservation(travelCode) {
    var url = 'ds/formdata?code=Travel';
    if (this.mode == '2' || this.mode == '3') {
      url += '&val=' + travelCode;
      this.enregist = true;
    }
    this.generalService.rechercheTable(url).subscribe((data) => {
      this.dsReservation = data;
      console.log(data);
      this.genererDetailReservation();
    });
  }

  OriginalTarvel;
  getDsReservation(travelCode) {
    var url = 'ds/formdata?code=Travel';
    this.totalGlobal = {};
    if (this.mode == '2' || this.mode == '3') {
      url += '&val=' + travelCode;
      this.enregist = true;
      //this.refreshList();
    }
    this.generalService.rechercheTable(url).subscribe((data) => {
      console.log(this.braquetResult);
      this.dsReservation = data;
      if (this.braquetResult) {
        this.handleModificationCircuitByCodeBraquet(this.braquetResult);
      }
      this.dsReservation.TravelD.sort((a, b) => {
        const toMinutes = (time: string) => {
          const [h, m] = time.split(':').map(Number);
          return h * 60 + m;
        };
        return toMinutes(a.TravelD_HFin) - toMinutes(b.TravelD_HFin);
      });

      this.OriginalTarvel = { ...this.dsReservation.Travel[0] };
      this.travelPrices = this.dsReservation.TravelDM;

      console.log(data);

      this.travelIsCalculated =
        this.dsReservation.Travel[0].Travel_statut == 10;

      if (this.dsReservation.Travel[0].Travel_Nature == 1)
        this.standardMode = true;

      this.generalService
        .rechercheTable2(
          'API_CalculTotalModif',
          this.dsReservation.Travel[0].Travel_Code
        )
        .subscribe((res: any) => {
          // TODO:
          console.log(res);
          this.ListCalculModif = res;

          if (this.dsReservation.Travel[0].Travel_statut >= 10) {
            this.totalGlobal.Pi = res[res.length - 1]['Prix individuel'];
            this.totalGlobal.Si = res[res.length - 1]['Total indiv'];
            this.totalGlobal.Sc = res[res.length - 1]['Total Coll'];
            this.totalGlobal.Ss = res[res.length - 1]['Total Supp'];
            this.totalGlobal.tva = res[res.length - 1]['TotalTVA'];
            this.totalGlobal.Total_Single = res[res.length - 1]['Total Single'];
            this.totalGlobal.Total_Supp = res[res.length - 1]['Total Supp'];
            this.totalGlobal.frais_staff = res[res.length - 1]['Total Staff'];
            this.totalGlobal.MargeIndColl =
              res[res.length - 1]['Marge IndColl'];
            this.totalGlobal.MargeSingle = res[res.length - 1]['Marge Single'];
            this.totalGlobal.MargeSupp = res[res.length - 1]['Marge Supp'];
            this.totalGlobal.Marge_Circuit =
              res[res.length - 1]['Marge_Circuit'];
            this.totalGlobal.TVA_Marge = res[res.length - 1]['TVA_Marge'];
            this.totalGlobal.totalTTC = res[res.length - 1]['Total'];
          }
        });

      this.dsReservationInit = JSON.parse(JSON.stringify(data));
      if (this.mode == '1')
        this.dsReservation.Travel[0].Travel_Code = new Date()
          .getTime()
          .toString();
      this.reservation = this.dsReservation.Travel[0];
      this.initCircuit.push(this.reservation);

      if (this.dsReservation.TravelD.length != 1)
        this.pos =
          this.dsReservation.TravelD[
            this.dsReservation.TravelD.length - 1
          ].TravelD_Pos;

      this.exist = true;
      if (this.mode == '1') {
        this.enregist = false;
        this.reservation.Travel_Nature = 0;
        this.reservation.Travel_NbJour = 1;
        this.reservation.Travel_NbPerso = 0;
        this.reservation.Travel_NbAccompagnant = 0;
        this.reservation.Travel_NbGuide = 1;
        this.reservation.Travel_NbChauffeur = 1;
        this.reservation.Travel_version = 1;
        this.reservation.Travel_TVA = 7;
        this.reservation.Tiers_code = '';
        this.clientComponent.clearText();
      } else {
        this.genererDetailReservation();
      }
      if (this.standardMode) {
        this.pageTitle = 'Modèle';
      } else {
        this.pageTitle = 'Circuit';
        // Check if the 'import' button already exists
        const hasImportButton = this.listBtn.some(
          (button) => button.name === 'import'
        );

        if (!hasImportButton) {
          this.listBtn = [
            ...this.listBtn,
            {
              name: 'import',
              class: 'colorBlueInfo',
              text: 'Importer Modèle',
              icon: 'file_download',
            },
          ];
        }
      }
      console.log('standardMode : ' + this.standardMode);
      console.log('listBtn : ' + this.listBtn);
    });
  }

  listeTypeText;
  genererDetailReservation() {
    for (var i = 1; i < this.reservation.Travel_NbJour + 2; i++) {
      var listeRreservationD = this.generalService.sort(
        this.dsReservation.TravelD.filter((reservationD) => {
          return reservationD.TravelD_Jour == i;
        }),
        'TravelD_HDeb'
      );
      listeRreservationD.forEach((reservationD) => {
        // this.generalService.rechercheTable2('API_textType',reservationD.TravelD_TypeEvent+','+reservationD.TravelD_Type).subscribe(res=>{

        //   console.log(res);
        //   this.listeTypeText =res
        //   var typeTextField=res[0].text
        //   console.log(typeTextField);

        var TravelD_TypeEvent = this.listeTypeEvennement.find(
          (TravelD_TypeEvent) => {
            return (
              TravelD_TypeEvent.TravelD_TypeEvent ==
              reservationD.TravelD_TypeEvent.toString()
            );
          }
        );

        var TravelD_Type = this.listeType.find((TravelD_TypeEvent) => {
          return (
            TravelD_TypeEvent.value == reservationD.TravelD_Type &&
            reservationD.TravelD_TypeEvent ==
              Number(TravelD_TypeEvent.TravelD_TypeEvent)
          );
        });

        var typeTextField = this.handleReservationDetail(
          reservationD.TravelD_TypeEvent,
          reservationD.TravelD_Type
        );

        reservationD.typeEvennementText = TravelD_TypeEvent
          ? TravelD_TypeEvent.text
          : '';
        reservationD.typeText = TravelD_Type ? TravelD_Type.text : '';
        reservationD.TravelD_Km = reservationD.TravelD_Km + ' Km';
        // reservationD.typeText = typeTextField ? typeTextField.__zone_symbol__value[0].text :''

        // reservationD.Tiers_RS = reservationD.Tiers_code
        // reservationD.Tiers_RS = reservationD.Tiers_code
      });

      this.listeReservationDetail.push({
        liste: listeRreservationD,
      });
      // console.log(this.listeReservationDetail);
    }

    // if (this.listeReservationDetail[0].liste[0])
    //   this.listeReservationDetail[0].liste[0].TravelD_Km =
    //     this.listeReservationDetail
    //       .filter((_, i) => i !== 0)
    //       .reduce(
    //         (a, b: any) => a + b.liste.reduce((c, d) => c + d.TravelD_Km, 0),
    //         0
    //       );
    //this.listeConmponent.toArray()[this.index].dataSource.sort((a, b) => parseInt(a.TravelD_HDeb.split(':')[0]) - parseInt(b.TravelD_HDeb.split(':')[0]))
    // this.listeReservationDetail.forEach(e => {
    //   e.liste.sort((a, b) => (parseInt(a.TravelD_HDeb.split(':')[0]) - parseInt(b.TravelD_HDeb.split(':')[0])))
    // })
    //console.log(this.listeReservationDetail)
    //this.refreshList()
  }

  async handleReservationDetail(param1, param2) {
    // let promise = new Promise((resolve, reject) => {
    //   this.generalService.rechercheTable2('API_textType',param1+','+param2).toPromise()
    // });
    //
    let promise = await this.generalService
      .rechercheTable2('API_textType', param1 + ',' + param2)
      .toPromise();
    console.log(promise);
    return promise;
  }

  goToListeReservation() {
    this.router.navigate(['avt/grh/liste/reservation']);
  }
  lastEventSelected = 0;
  numTypEvenement = 0;

  typeEvennementChange(event?, bool?) {
    console.log(this.listeTypeEvennement);
    console.log(event);
    if (event) {
      if (
        event.action != 'dbClick' &&
        this.lastEventSelected != parseInt(this.reservationD.TravelD_TypeEvent)
      ) {
        this.reservationD.TravelD_Event = null;
        this.villeComponent.clearText();
        this.fournisseurComponent.clearText();
      }
      if (bool) {
        this.reservationD.TravelD_TypeEvent = parseInt(
          this.reservationD.TravelD_TypeEvent
        );
      }
      if (event == 1) {
        this.TravelD_TypeLabel = 'arrangement';
      }
      if (event !== 0 && event !== 1) {
        this.TravelD_TypeLabel = 'TYPE';
      }
    }
    this.numTypEvenement = event;
    if (this.generalService.isNotEmpty(this.reservationD.TravelD_TypeEvent)) {
      // initialiser when change type event
      this.listeEvennementFiltred = this.listeEvennement.filter((typeEv) => {
        return typeEv.TravelD_TypeEvent == this.reservationD.TravelD_TypeEvent;
      });
      this.listeTypeFiltred = this.listeType.filter((type) => {
        return type.TravelD_TypeEvent == this.reservationD.TravelD_TypeEvent;
      });
      console.log(this.listeEvennementFiltred);
      console.log(this.listeTypeFiltred);

      this.reservationD.TravelD_TypFournisseur = this.listeTypeEvennement.find(
        (typeEvent) => {
          return (
            typeEvent.TravelD_TypeEvent == this.reservationD.TravelD_TypeEvent
          );
        }
      ).TravelD_TypFournisseur;

      // this.generalService.rechercheTable('API_Observation', this.listeEvennementFiltred[0].evennemtCode).subscribe(obs => {
      //   this.reservationD.TravelD_Obs = obs[0].observation
      // })
    }
    this.lastEventSelected = parseInt(this.reservationD.TravelD_TypeEvent);
    //console.log(this.listeEvennementFiltred);
  }

  autoFill_Logistic_choose() {
    if (this.listeTypeFiltred[0].TravelD_TypeEvent == 3) {
      this.fournisseurComponent.param =
        this.reservationD.TravelD_TypFournisseur;
      this.fournisseurComponent.param2 = this.reservationD.TravelD_Ville;
      this.reservationD.Tiers_RS = 'BATOUTA';
      this.reservationD.TravelD_TypFournisseur = '3';
      this.reservationD.TravelD_Type = 0;
    }
  }

  heurechange(event) {
    if (this.generalService.isNotEmpty(event.target.value)) {
      this.filterdTime = this.time.filter((val) => {
        return val.indexOf(event.target.value) >= 0;
      });
      if (this.filterdTime.length == 0)
        event.target.value = event.target.value.substr(
          0,
          event.target.value.length - 1
        );
    } else this.filterdTime = this.time.slice();
  }
  heureBlur(event) {
    this.filterdTime = this.time.slice();
    event.target.value = this.dateService.setFormaTime(event.target.value);
    if (
      this.generalService.isNotEmpty(event.target.value) &&
      this.filterdTime.length > 0 &&
      this.filterdTime.find((time) => {
        return time == event.target.value;
      }) == undefined
    ) {
      event.target.value = this.filterdTime[0];
    }
    this.setTravelD_HFin();
  }
  HourFin;
  MinFin;
  DureeInt;
  setTravelD_HFin() {
    this.HourFin = 0;
    this.MinFin = 0;
    if (
      this.generalService.isNotEmpty(this.reservationD.TravelD_HDeb) &&
      this.generalService.isNotEmpty(this.reservationD.TravelD_Duree)
    ) {
      this.reservationD.TravelD_HFin = this.changecalculerHeur(
        this.reservationD.TravelD_HDeb,
        this.reservationD.TravelD_Duree
      );
      if (this.reservationD.TravelD_HFin) {
        this.MinFin = parseInt(this.reservationD.TravelD_HFin.split(':')[1]);
        this.HourFin = parseInt(this.reservationD.TravelD_HFin.split(':')[0]);
      }
    }
    if (typeof this.reservationD.TravelD_Duree == 'string') {
      this.reservationD.TravelD_Duree =
        parseInt(this.reservationD.TravelD_Duree.split(':')[0]) * 60 +
        parseInt(this.reservationD.TravelD_Duree.split(':')[1]);
    }
    // else if(typeof(this.reservationD.TravelD_Duree)=='number')
    // {
    //
    // }
  }

  Tiers_Code;
  blurFournisseur(event) {
    console.log(event);
    this.reservationD.Tiers_code = event;
    this.generalService
      .rechercheTable2(
        'batfour',
        this.reservationD.TravelD_TypFournisseur +
          ',' +
          this.reservationD.TravelD_Ville
      )
      .subscribe((res: any) => {
        this.reservationD.Tiers_RS = res.find(
          (fournisseur) => fournisseur.Tiers_code == event
        ).Tiers_RS;
        var fournisseur = res.find(
          (fournisseur) => fournisseur.Tiers_code == event
        );
        console.log(fournisseur);
        this.Tiers_Code = fournisseur.Tiers_code;
      });

    if (!this.numTypEvenement) this.numTypEvenement = 0;

    var param = this.numTypEvenement + ',' + this.reservationD.Tiers_code;

    console.log(param);

    // if (this.reservationD.Tiers_code && this.numTypEvenement == 0) {
    //   this.generalService
    //     .rechercheTable2('Api_listeType', param)
    //     .subscribe((res) => {
    //       console.log(res);
    //       this.listeTypeFiltred = res;
    //     });
    // }
  }

  navigateToTarifTable_EasyAcces(param) {
    console.log(param);
    const baseUrl = '/avt/grh/tarif/reservation';
    const queryParams = `code_fournisseur=${param}`;
    const urlWithParams = `${baseUrl}?${queryParams}`;
    window.open(
      urlWithParams,
      '_blank',
      'height=' + window.innerHeight * 0.8 + ',width=' + window.innerWidth * 1.2
    );
    return false;
  }

  navigateToFournisseurTable_EasyAcces() {
    const baseUrl = '/avt/grh/fournisseur/reservation';
    window.open(
      baseUrl,
      '_blank',
      'height=' + window.innerHeight * 0.8 + ',width=' + window.innerWidth * 1.2
    );
    return false;
  }
  navigateToTarifsTable_EasyAcces() {
    const baseUrl = '/avt/grh/tarif/reservation';
    window.open(
      baseUrl,
      '_blank',
      'height=' + window.innerHeight * 0.8 + ',width=' + window.innerWidth * 1.2
    );
    return false;
  }

  NomFournisseur;
  getFournisseurByTiersCode(TiersCode) {
    this.generalService.rechercheTable2('batfour').subscribe((res: any) => {
      console.log(res);
    });
  }

  getDateOfDaySelected(listDay) {}

  detailMenu;
  menuDiagRef;
  getInfoMenuTarif() {
    console.log(this.listeReservationDetail);
    console.log(this.dsReservation.Travel[0]);
    var dateDeb = new Date(
      JSON.stringify(this.dsReservation.Travel[0].Travel_DateDeb).substring(
        1,
        11
      )
    ).toLocaleDateString('fr-CA');
    var Day = parseInt(dateDeb.substring(8, 11));
    var date = new Date(dateDeb).setDate(this.indexJour - 2 + Day);
    var dateJourSelected = new Date(date).toLocaleDateString('fr-CA');

    var param2 =
      dateJourSelected +
      ',' +
      this.reservationD.Tiers_code +
      ',' +
      this.dsReservation.Travel[0].Travel_NbPerso;

    if (this.numTypEvenement == 0 || this.reservationD.TravelD_TypeEvent == 0) {
      console.log('show calcul Menu + Menu');
      this.generalService
        .rechercheTable2('API_calculLigneResto', param2)
        .subscribe((res) => {
          console.log(res);
          this.ListTarif = res;
        });

      this.menuDiagRef = this.generalService.dialog.open(this.frmMenuTarif, {
        width: '100%',
      });

      this.generalService.dialog.afterAllClosed.subscribe(() => {
        this.ListTarif = [];
        console.log(this.ListTarif);
      });
    } else {
      console.log(param2 + this.typeEvent);

      if (
        (this.typeEvent == 0 || this.typeEvent) &&
        this.reservationD.Tiers_code
      ) {
        this.generalService
          .rechercheTable2('API_CalculLigne', param2 + ',' + this.typeEvent)
          .subscribe(
            (data) => {
              console.log(data);
              this.ListTarif = data;

              this.generalService.dialog.open(this.frmMenuTarif, {
                width: '60vw',
              });

              this.generalService.dialog.afterAllClosed.subscribe(() => {
                this.ListTarif = [];
              });
            },
            () => {
              if ((dateJourSelected = 'Invalid Date'))
                this.generalService.dialogSuccess(
                  'La date est invalide!',
                  false
                );
              else
                this.generalService.dialogSuccess(
                  'vérifier votre données ',
                  false
                );
            }
          );
      }
    }

    if (!this.ListTarif || this.ListTarif.length == 0) {
      // if(!this.typeEvent )
      // this.generalService.dialogSuccess(
      //   'vérifier le choix de type évenement',
      //   false,4000
      // );
      if (!this.reservationD.Tiers_code)
        this.generalService.dialogSuccess(
          'vérifier le choix  fournisseur',
          false,
          4000
        );
    }
  }

  choixMenu;
  rowClickMenu(row) {
    console.log(row);
    this.choixMenu = row.Code_Menu;

    this.reservationD.TravelD_Type = row.value;
    this.menuChoixWithPrice = row;
  }

  closeChoixMenu() {
    this.menuDiagRef.close();
  }

  //Get Tier_code Client while change of value
  Tiers_RS;
  blurClient(event) {
    this.reservation.Tiers_code = event;
    this.generalService.rechercheTable2('client').subscribe((res: any) => {
      // console.log(res);
      // console.log(this.reservation);
    });
  }

  blurVille(event) {
    // console.log(event);
    this.reservationD.TravelD_Ville = event;
    this.autoFill_Logistic_choose();
  }
  dateActionChange(peride) {
    if (peride == 'DATEARRIVEE') {
      if (this.generalService.isNotEmpty(this.reservation.Travel_DateFin)) {
        var Travel_DateDeb = new Date(this.reservation.Travel_DateDeb);
        var depar = new Date(this.reservation.Travel_DateFin);
        if (
          Travel_DateDeb.getTime() > depar.getTime() &&
          Travel_DateDeb.getTime() != depar.getTime()
        ) {
          this.generalService.dialogSuccess(
            "La date d'arrivée doit être inférieur à la date de départ",
            false
          );
        }
      } else {
        this.reservation.Travel_DateFin = this.generalService.clone(
          this.reservation.Travel_DateDeb
        );
      }
    } else if (peride == 'DATEDEPART') {
      if (
        this.reservation.Travel_DateDeb != undefined &&
        this.reservation.Travel_DateDeb != null
      ) {
        var Travel_DateDeb = new Date(this.reservation.Travel_DateDeb);
        var depar = new Date(this.reservation.Travel_DateFin);
        if (Travel_DateDeb.getTime() > depar.getTime()) {
          this.generalService.dialogSuccess(
            'La date de départ doit être supperieur à la date de arrivée',
            false
          );
        }
      } else {
        this.reservation.Travel_DateDeb = this.generalService.clone(
          this.reservation.Travel_DateFin
        );
      }
    }
    // ? Calculating nb jour

    console.log(this.reservation);
    const startDate = new Date(this.reservation.Travel_DateDeb);
    const endDate = new Date(this.reservation.Travel_DateFin);
    const timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
    const nbJour = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;

    this.reservation.Travel_NbJour = nbJour;
  }
  nbJourChanged() {
    let startingDate = new Date(this.reservation.Travel_DateDeb);
    startingDate.setDate(
      startingDate.getDate() + this.reservation.Travel_NbJour
    );
    this.reservation.Travel_DateFin = startingDate;
  }
  verifReadOnly(index) {
    //console.log(index);
    if (this.listeReservationDetail[index].liste.length >= 1) {
      this.ChangeHdeb = false;
      //console.log(this.ChangeHdeb);
    } else {
      this.ChangeHdeb = false;
      //console.log(this.ChangeHdeb);
    }
    if (this.modifActive) this.ChangeHdeb = false;
  }

  code_Event;
  codeEvent(event) {
    this.code_Event = this.listeEvennementFiltred.find(
      (e) => e.TravelD_Event == event.value
    ).evennemtCode;
    console.log(this.code_Event);
  }

  normalizeTime(time: string): string {
    if (!time) return '00:00';

    // Only modify if format length is less than 5 (e.g., "6:5" or "6:50")
    if (time.length < 5) {
      let [h, m] = time.split(':');
      h = h.padStart(2, '0');
      m = (m ?? '0').padStart(2, '0');
      return `${h}:${m}`;
    }

    return time; // Already correct
  }

  TravelD_Type;
  ajouterDetailReservation(form: NgForm) {
    console.log(this.pos);
    if (this.indexJour == 1 && this.bouton == 'ajouter') {
      this.reservationD.TravelD_HFin = this.reservationD.TravelD_HDeb;
      this.reservationD.TravelD_Duree = 0;
      console.log('***********', this.reservationD.TravelD_Duree);
    }
    if (this.dsReservation && this.dsReservation.Travel[0].Travel_Code) {
      if (form.valid) {
        //console.log(this.listeReservationDetail);
        if (this.bouton == 'ajouter') {
          var TravelD_TypeEvent = this.listeTypeEvennement.find(
            (TravelD_TypeEvent) =>
              TravelD_TypeEvent.TravelD_TypeEvent ==
              this.reservationD.TravelD_TypeEvent
          );
          this.TravelD_Type = this.listeTypeFiltred.find(
            (TravelD_TypeEvent) => {
              return TravelD_TypeEvent.value == this.reservationD.TravelD_Type;
            }
          );
          console.log(TravelD_Type);
          console.log(this.listeTypeFiltred);

          //console.log(this.reservationD.Tiers_RS)
          //if (this.reservationD.Tiers_RS) {

          this.listeConmponent.toArray()[this.index].dataSource.push({
            id: null,
            TravelD_Jour: this.TravelD_Jour,
            Travel_Code: this.dsReservation.Travel[0].Travel_Code,
            TravelD_TypeEvent: this.generalService.isNotEmpty(
              this.reservationD.TravelD_TypeEvent
            )
              ? this.reservationD.TravelD_TypeEvent
              : '',
            typeEvennementText: TravelD_TypeEvent ? TravelD_TypeEvent.text : '',
            typeText: this.TravelD_Type ? this.TravelD_Type.text : '',
            TravelD_Event: this.reservationD.TravelD_Event
              ? this.reservationD.TravelD_Event
              : '',
            TravelD_Ville: this.reservationD.TravelD_Ville
              ? this.reservationD.TravelD_Ville
              : '',
            Tiers_code: this.reservationD.Tiers_code
              ? this.reservationD.Tiers_code
              : '',
            TravelD_Km: this.reservationD.TravelD_Km
              ? this.reservationD.TravelD_Km
              : 0,
            TravelD_DureeTrajet: this.reservationD.TravelD_DureeTrajet
              ? this.reservationD.TravelD_DureeTrajet
              : 0,
            TravelD_NbreVoiture: this.reservationD.TravelD_NbreVoiture
              ? this.reservationD.TravelD_NbreVoiture
              : '',
            Tiers_RS: this.reservationD.Tiers_RS
              ? this.reservationD.Tiers_RS
              : '',
            TravelD_Type: this.generalService.isNotEmpty(
              this.reservationD.TravelD_Type
            )
              ? this.reservationD.TravelD_Type
              : '',
            TravelD_Obs: this.reservationD.TravelD_Obs
              ? this.reservationD.TravelD_Obs
              : '',
            TravelD_HDeb: this.reservationD.TravelD_HDeb
              ? this.normalizeTime(this.reservationD.TravelD_HDeb)
              : '',
            TravelD_HFin: this.reservationD.TravelD_HFin
              ? this.normalizeTime(this.reservationD.TravelD_HFin)
              : '',
            TravelD_Duree: this.reservationD.TravelD_Duree
              ? this.reservationD.TravelD_Duree
              : 0,

            TravelD_Obs1: this.reservationD.TravelD_Obs1
              ? this.reservationD.TravelD_Obs1
              : '',
            U_timestamp: null,
            TravelD_Modif: this.reservation.Travel_statut1 == 1 ? 1 : 0,
            TravelD_EventCode: this.code_Event,
            TravelD_Pos: ++this.pos,
          });
          if (this.indexJour == 1 && this.bouton == 'ajouter') {
            this.reservationD.TravelD_Duree = 0;
          }
          this.reservationD = {};
          const lastLine =
            this.listeConmponent.toArray()[this.index].dataSource[
              this.listeConmponent.toArray()[this.index].dataSource.length - 1
            ];
          //   this.reservationD.TravelD_HDeb = this.calculerHeur(
          //     lastLine.TravelD_HFin,
          //     lastLine.TravelD_DureeTrajet
          //   );
          this.close();
          // if (this.reservationD.Tiers_RS) {
          this.listeConmponent.toArray()[this.index].dataSource =
            this.SortByHDeb_Generic(
              this.listeConmponent.toArray()[this.index].dataSource
            );

          this.reglageHorair_Generic(
            this.listeConmponent.toArray()[this.index].dataSource,
            this.listeConmponent.toArray()[this.index].dataSource[0]
              .TravelD_HDeb
          );
          var lastHFin = lastLine.TravelD_HFin;

          if (this.verifyEndDay_Generic(lastHFin)) {
            if (lastLine.TravelD_TypeEvent == 1) {
              this.get_Last_Herbergement_Detail(lastLine);
              // if (!this.standardMode)
              //   this.generate_petit_dej_after_Hebergement(lastLine);
            }

            this.enregistrer();
            this.orderListeReservationDetail(this.index);
            //this.refreshList();
          } else {
            this.generalService.dialogSuccess(
              'désolé votre journée a été terminé',
              false
            );
            this.listeConmponent
              .toArray()
              [this.index].dataSource.splice(
                this.listeConmponent.toArray()[this.index].dataSource.length -
                  1,
                1
              );
          }
        }
        if (this.bouton == 'modifier') {
          console.log(this.listeOpend.row);

          var TravelD_TypeEvent = this.listeTypeEvennement.find(
            (TravelD_TypeEvent) => {
              return (
                TravelD_TypeEvent.TravelD_TypeEvent ==
                this.reservationD.TravelD_TypeEvent.toString()
              );
            }
          );
          var TravelD_Type = this.listeTypeFiltred.find((TravelD_TypeEvent) => {
            return TravelD_TypeEvent.value == this.reservationD.TravelD_Type;
          });
          this.listeOpend.row.typeEvennementText = TravelD_TypeEvent
            ? TravelD_TypeEvent.text
            : '';
          this.listeOpend.row.typeText = TravelD_Type ? TravelD_Type.text : '';
          (this.listeOpend.row.TravelD_EventCode = !this.code_Event
            ? this.reservationD.TravelD_EventCode
            : this.code_Event),
            (this.listeOpend.row.TravelD_TypeEvent =
              this.reservationD.TravelD_TypeEvent);
          this.listeOpend.row.Tiers_code = this.reservationD.Tiers_code;
          this.listeOpend.row.TravelD_Ville = this.reservationD.TravelD_Ville;
          this.listeOpend.row.TravelD_Event = this.reservationD.TravelD_Event;
          this.listeOpend.row.TravelD_Type = this.reservationD.TravelD_Type;
          this.listeOpend.row.TravelD_Km = this.reservationD.TravelD_Km;
          this.listeOpend.row.TravelD_NbreVoiture =
            this.reservationD.TravelD_NbreVoiture;
          //console.log(this.reservationD.TravelD_DureeTrajet)
          this.listeOpend.row.TravelD_DureeTrajet =
            this.reservationD.TravelD_DureeTrajet;
          // *****************************************************************************
          this.listeOpend.row.TravelD_HDeb = this.normalizeTime(
            this.reservationD.TravelD_HDeb
          );
          this.listeOpend.row.TravelD_Duree = this.dureeStringNumber(
            this.reservationD.TravelD_Duree
          );
          // this.listeOpend.row.TravelD_HFin = this.reservationD.TravelD_HFin;
          this.listeOpend.row.TravelD_HFin = this.changecalculerHeur(
            this.listeOpend.row.TravelD_HDeb,
            this.listeOpend.row.TravelD_Duree
          );
          this.listeOpend.row.TravelD_HFin = this.changecalculerHeur(
            this.listeOpend.row.TravelD_HFin,
            this.listeOpend.row.TravelD_DureeTrajet
          );

          this.listeOpend.row.TravelD_Obs = this.reservationD.TravelD_Obs;
          this.listeOpend.row.TravelD_Obs1 = this.reservationD.TravelD_Obs1;
          this.listeOpend.row.Tiers_RS = this.reservationD.Tiers_RS;
          this.listeOpend.row.TravelD_Pos = this.reservationD.TravelD_Pos;
          this.listeOpend.row.TravelD_Modif =
            this.reservationD.TravelD_Modif = 1;
          var data = this.listeOpend.getDataSource();
          //console.log(data);

          if (this.listeOpend.rowIndex + 1 <= data.length)
            for (var i = this.listeOpend.rowIndex + 1; i < data.length; i++) {
              if (data[i - 1].TravelD_HFin) {
                data[i].TravelD_HDeb = this.changecalculerHeur(
                  data[i - 1].TravelD_HFin,
                  data[i].TravelD_DureeTrajet
                );
                data[i].TravelD_HFin = this.changecalculerHeur(
                  data[i].TravelD_HDeb,
                  data[i].TravelD_Duree
                );
              }
            }

          var ListTravelDMtoDelete;
          var newListTravelDM;
          if (
            this.dsReservation.TravelDM ||
            this.dsReservation.TravelDM.length > 0
          ) {
            ListTravelDMtoDelete = this.dsReservation.TravelDM.filter(
              (e) =>
                e.TravelD_Jour == this.listeOpend.row.TravelD_Jour &&
                e.TravelD_Pos == this.listeOpend.row.TravelD_Pos
            );
            console.log(ListTravelDMtoDelete);

            this.dsReservation.TravelDM = this.suppListfromlist(
              this.dsReservation.TravelDM,
              ListTravelDMtoDelete
            );
          }

          this.close();
          // const lastLine =
          //   this.listeOpend.dataSource[
          //   this.listeOpend.dataSource.length - 1
          //   ];
          //   var lastHFin =lastLine.TravelD_HDeb
          //   console.log(lastHFin);

          if (this.reservationD.Tiers_RS) {
            console.log(this.dsReservation);
            this.enregistrer();
            this.orderListeReservationDetail(this.index);
          } else this.generalService.dialogSuccess('Non enregistré', false);
          //this.refreshList(); zrgzrgergergerg
        }
      }
    } else
      this.generalService.dialogSuccess(
        'Veuillez patienter pendant le chargement total des données',
        false
      );
    this.HourFin = 0;
    this.MinFin = 0;
  }

  typeEvent;
  typeHerbergementSelected;
  selectType(event) {
    console.log(event);
    //this.typeEvent=event.TravelD_TypeEvent
    var TravelD_Type = this.listeType.find((TravelD_TypeEvent) => {
      return (
        TravelD_TypeEvent.value == this.reservationD.TravelD_Type &&
        this.reservationD.TravelD_TypeEvent ==
          Number(TravelD_TypeEvent.TravelD_TypeEvent)
      );
    });

    console.log(this.listeTypeFiltred);

    // this.typeEvent=TravelD_Type.value
    console.log(TravelD_Type);
    this.typeHerbergementSelected = TravelD_Type;
    this.typeEvent = event;
  }

  close() {
    this.generalService.dialog.closeAll();
  }
  output(event, listeConmponent, TravelD_Jour) {
    if (event.action == 'clickBtnHeat') {
      if (event.bouton.name == 'ajouter') {
        this.ajouter(listeConmponent, TravelD_Jour, event.bouton.name);
      }
      if (event.bouton.name == 'modifier') {
        this.modifier(event, event.bouton.name);
      }
      if (event.bouton.name == 'supprimer') {
        if (listeConmponent.listSelectedrows.length > 1)
          this.supprimerMultiple(event, listeConmponent);
        else this.supprimer(event, listeConmponent);
      }
      if (event.bouton.name == 'monter') {
        this.monterDescendre(listeConmponent, 1);
      }
      if (event.bouton.name == 'descendre') {
        this.monterDescendre(listeConmponent, -1);
      }
      if (event.bouton.name == 'Info') {
        this.showInfo(listeConmponent);
      }
      if (event.bouton.name == 'import') {
        this.showListImportStandar(listeConmponent);
      }
      if (event.bouton.name == 'RH') {
        console.log(this.SortByHDeb_Generic(listeConmponent.dataSource));
        listeConmponent.dataSource = this.SortByHDeb_Generic(
          listeConmponent.dataSource
        );
      }
    } else {
      if (event.action == 'dbClick') this.modifier(event, 'modifier');
      // console.log(event);

      if (event.action == 'CheckedRows') {
        console.log(event);
      }
    }
  }

  TotalMarge;
  lineSelected;

  detailCout;
  detailCoutSupp;
  showDetailSupp() {
    this.detailCout = this.dsReservation.TravelDM.filter(
      (e) => e.Travel_Code == this.dsReservation.ApiForm[0].For_Val
    );
    // console.log(this.detailCout);

    this.detailCoutSupp = this.detailCout.reduce((a, b) => {
      if (!b.TravelDM_Supp_Modif || b.TravelDM_Supp_Modif == 0)
        return (a || 0) + (b.TravelDM_SUPP || 0) + (b.TravelDM_Marge || 0);
      else
        return (
          (a || 0) + (b.TravelDM_Supp_Modif || 0) + (b.TravelDM_Marge || 0)
        );
    }, 0);
    console.log(this.detailCout);

    this.generalService.dialog.open(this.frmDetaiSupp, { width: '70vw' });
    this.generalService.dialog.afterAllClosed.subscribe(() => {
      this.detailCout = [];
    });
  }

  TotalSuppDevise;
  ListSupp;
  ListSuppSingle;
  TotalSuppSingle;
  TotalSuppSingleDevise;
  showDetailCalcul() {
    console.log(this.reservation);
    console.log(this.ListCalculModif);

    this.ListSuppSingle = this.ListCalculModif.filter(
      (e) => e.Observation == 'SINGLE'
    );
    console.log(this.ListSuppSingle);

    this.ListSupp = this.ListCalculModif.filter(
      (e) =>
        e.Observation != 'SINGLE' &&
        e.TravelDM_SUPP != 0 &&
        e.TravelDM_SUPP != null
    );
    // this.ListSupp.splice(-1)
    console.log(this.ListSupp);

    this.detailCout = this.dsReservation.TravelDM.filter(
      (e) => e.Travel_Code == this.dsReservation.ApiForm[0].For_Val
    );
    console.table(this.detailCout);

    this.calculerTotals();

    this.generalService.dialog.open(this.frmDetailCalcul, {
      width: '90vw',
      maxWidth: '100vw',
    });
    this.generalService.dialog.afterAllClosed.subscribe(() => {
      this.detailCout = [];
      //this.saveTauxMarge(this.dsReservation.Travel[0].Travel_Marge)
    });
  }

  calculTotalSuppDevise(TotalSupp, coef) {
    return TotalSupp / coef;
  }
  TypeEvenment;
  ListTarif;
  showInfo(list) {
    this.TypeEvenment = list.dataSource[list.rowIndex];
    var thing = list;
    var eventPrice = this.travelPrices;
    console.log(eventPrice);
    console.log(thing);
    console.log(this.TypeEvenment);
    this.eventPrices = this.travelPrices.find(
      (attr: any) => attr.TravelD_id == thing.row.id
    );
    console.log(this.eventPrices);
    this.generalService.dialog.open(this.frmInfo, { width: '70vw' });
    this.generalService.dialog.afterAllClosed.subscribe(() => {});
  }

  dsStandard;
  detailStandard;
  messageInformedForDeailModel;
  indexModelSelected;
  getDScircuit(travelCode) {
    var url = 'ds/formdata?code=Travel';
    this.totalGlobal = {};
    if (this.mode == '2' || this.mode == '3') {
      url += '&val=' + travelCode;
    }
    this.generalService.rechercheTable(url).subscribe((data) => {
      this.dsStandard = data;
      console.log(this.dsStandard.TravelD);
      if (this.dsStandard.TravelD[0].id != null)
        this.detailStandard = this.dsStandard.TravelD;
      else {
        this.detailStandard = [];
        this.messageInformedForDeailModel =
          'Le modèle ' +
          this.dsStandard.Travel[0].Travel_Nom +
          ' ne possède pas de détail.';
      }

      this.listselcted = [];
    });
  }

  indexJour;
  lastHFin;
  async getIndexJour(index) {
    console.log('worked');
    let aux = [];
    this.indexJour = index + 1;
    console.log(this.indexJour);
    console.log(this.listeReservationDetail);
    if (this.listeReservationDetail[index].liste.length > 0) {
      this.lastHFin =
        this.listeReservationDetail[index].liste[
          this.listeReservationDetail[index].liste.length - 1
        ].TravelD_HFin;
      console.log(this.lastHFin);

      if (this.verifyEndDay_Generic(this.lastHFin))
        this.listeReservationDetail.forEach((e) => {
          e.liste = this.SortByHDeb_Generic(e.liste);
        });
      console.log(this.listeReservationDetail[index]);
    }
  }
  async orderListeReservationDetail(index) {
    let aux = [];
    console.log(this.listeReservationDetail);
    aux = this.SortByHDeb_Generic(this.listeReservationDetail[index].liste);
    this.listeReservationDetail[index].liste = [];
    await this.delay(300);
    this.listeReservationDetail[index].liste = aux;
    console.log(this.listeReservationDetail[index]);
  }

  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  listselcted = [];
  getStandarChecked(event) {
    var ItemSelcted;
    var ItemDeselcted;

    if (event.target.checked) {
      ItemSelcted = this.detailStandard.filter(
        (e) => e.id == event.target.value
      );
      this.listselcted.push(ItemSelcted[0]);
    } else {
      ItemDeselcted = this.detailStandard.filter(
        (e) => e.id == event.target.value
      );
      var indexTodelet = this.listselcted.indexOf(ItemDeselcted[0]);
      console.log(indexTodelet);

      this.listselcted.splice(indexTodelet, 1);
      this.isAllSelectedStandarList = false;
    }
    console.log(this.listselcted);
  }

  isAllSelectedStandarList = false;
  toggleAllModelStandard(isAllSelected) {
    var checkboxes = document.getElementsByName('model_standard');

    if (isAllSelected) {
      for (var i = 0, n = checkboxes.length; i < n; i++) {
        (checkboxes[i] as HTMLInputElement).checked = true;
      }
      this.listselcted = this.detailStandard;
      this.isAllSelectedStandarList = true;
    } else {
      for (var i = 0, n = checkboxes.length; i < n; i++) {
        (checkboxes[i] as HTMLInputElement).checked = false;
      }
      this.isAllSelectedStandarList = false;
      this.listselcted = [];
    }
  }

  importStandard() {
    this.route.params.subscribe((params) => {
      var travelCode = params['param'];
      this.mode = params['mode'];
      console.log(this.listselcted);

      this.listselcted.forEach((detStd) => {
        if (this.mode != 1) detStd.Travel_Code = travelCode;
        else detStd.Travel_Code = this.dsReservation.Travel[0].Travel_Code;

        if (this.reservation.Travel_statut1 == 1) detStd.TravelD_Modif = 1;
        else detStd.TravelD_Modif = 0;

        detStd.TravelD_Pos = ++this.pos;
        detStd.TravelD_Jour = this.indexJour;
        detStd.U_timestamp = null;
      });
      console.log(this.listeReservationDetail);

      if (this.listeReservationDetail[this.indexJour - 1].liste.length != 0) {
        var newHdeb = this.genererNewHdebStandard(
          this.listeReservationDetail[this.indexJour - 1].liste
        );
        console.log(newHdeb);

        this.reglageHorair_Generic(this.listselcted, newHdeb);
      }
      this.dsReservation.TravelD = this.listselcted;
      console.log(this.dsReservation);
      const lastLine = this.listselcted[this.listselcted.length - 1];
      var lastHFin = lastLine.TravelD_HFin;
      console.log(lastHFin);

      if (this.verifyEndDay_Generic(lastHFin))
        this.generalService.enregisterTable(this.dsReservation).subscribe(
          (data) => {
            this.generalService.dialogSuccess('Enregistré', true);
            this.mode = '2';

            this.getDsReservation(this.dsReservation.Travel[0].Travel_Code);
            this.listselcted = [];
            this.listeReservationDetail = [];
            this.generalService.dialog.closeAll();
            //this.refreshList();
            this.enregist = true;
            this.pos =
              this.dsReservation.TravelD[
                this.dsReservation.TravelD.length - 1
              ].TravelD_Pos;
            for (let i = 1; i <= this.listeReservationDetail.length; i++) {
              this.orderListeReservationDetail(i);
            }
          },
          () => {
            this.exist = true;
            this.listselcted = [];
            this.generalService.dialogSuccess('Non enregistré', false);
            //this.refreshList();
          }
        );
      else
        this.generalService.dialogSuccess(
          'désolé votre journée a été terminé ! veuillez vérifier le temps !',
          false
        );
    });
    this.SortByHDeb_Generic(this.listeReservationDetail);
  }

  genererNewHdebStandard(ListDay) {
    if (ListDay) {
      var LastItemOfListDay = ListDay[ListDay.length - 1];
      var HFin_Minute =
        parseInt(LastItemOfListDay.TravelD_HFin.split(':')[0]) * 60 +
        parseInt(LastItemOfListDay.TravelD_HFin.split(':')[1]);
      var NewHDebOfnextItem_Minute =
        HFin_Minute + LastItemOfListDay.TravelD_DureeTrajet;

      let newHeurDeb = Math.floor(NewHDebOfnextItem_Minute / 60);
      let newMinuteDeb = NewHDebOfnextItem_Minute % 60;

      var newHDeb = newHeurDeb + ':' + newMinuteDeb;
    }
    return newHDeb;
  }

  ConvertisseurHoraire_Minute_Generic(ch) {
    if (!ch) ch = '00:00';
    return parseInt(ch.split(':')[0]) * 60 + parseInt(ch.split(':')[1]);
  }

  ConvertisseurHoraire_Chaine_Genric(minute) {
    var h = Math.floor(minute / 60);
    var m = minute % 60;

    var ch_h = h < 10 ? '0' + h : h;
    var ch_m = m < 10 ? '0' + m : m;

    return ch_h + ':' + ch_m;
  }

  genererHFin_Generic(HDeb, duree) {
    var hDeb_minute = this.ConvertisseurHoraire_Minute_Generic(HDeb);
    var HFin_Minute = hDeb_minute + duree;

    var Hfin = this.ConvertisseurHoraire_Chaine_Genric(HFin_Minute);
    return Hfin;
  }

  genererNewHDeb_Generic(HFin, dureeTrajet) {
    var hdeb_minute = this.ConvertisseurHoraire_Minute_Generic(HFin);
    var HDeb_Minute = hdeb_minute + dureeTrajet;

    var HDeb = this.ConvertisseurHoraire_Chaine_Genric(HDeb_Minute);

    return HDeb;
  }

  getMinHDeb_Generic(list) {
    var HdebMin;
    var listHdebMin = [];
    list.forEach((element) => {
      HdebMin = this.ConvertisseurHoraire_Minute_Generic(element.TravelD_HDeb);
      listHdebMin.push(HdebMin);
    });
    return this.ConvertisseurHoraire_Chaine_Genric(Math.min(...listHdebMin));
  }

  SortByHDeb_Generic(list) {
    return list.sort(
      (a, b) =>
        this.ConvertisseurHoraire_Minute_Generic(a.TravelD_HDeb) -
        this.ConvertisseurHoraire_Minute_Generic(b.TravelD_HDeb)
    );
  }
  getFirstLineReservationD(list) {
    return list.find((e) => e.TravelD_HDeb == this.getMinHDeb_Generic(list));
  }

  reglageHorair_Generic(List, HDeb) {
    //List[0]=this.getFirstLineReservationD(List)
    if (!HDeb && List.length == 1) HDeb = '00:00';

    List[0].TravelD_HDeb = HDeb;
    List[0].TravelD_HFin = this.genererHFin_Generic(
      HDeb,
      List[0].TravelD_DureeTrajet
    );
    List[0].TravelD_HFin = this.genererHFin_Generic(
      List[0].TravelD_HFin,
      List[0].TravelD_Duree
    );
    for (let i = 1; i < List.length; i++) {
      List[i].TravelD_HDeb = List[i - 1].TravelD_HFin;
      List[i].TravelD_HFin = this.genererNewHDeb_Generic(
        List[i].TravelD_HDeb,
        List[i].TravelD_DureeTrajet
      );
      List[i].TravelD_HFin = this.genererHFin_Generic(
        List[i].TravelD_HFin,
        List[i].TravelD_Duree
      );
    }
  }

  verifyEndDay_Generic(lastHfin) {
    var lastHfin_En_Minute = this.ConvertisseurHoraire_Minute_Generic(lastHfin);

    if (lastHfin_En_Minute >= 1440) return false;
    else return true;
  }

  listeStandards;
  showListImportStandar(list) {
    this.generalService.rechercheTable2('Api_travelS').subscribe(
      (data: any) => {
        this.listeStandards = data;
      },
      () => {
        this.generalService.dialogSuccess('pas de donnée disponible', false);
      }
    );
    this.generalService.dialog.open(this.frmImport, { width: '70vw' });
    this.generalService.dialog.afterAllClosed.subscribe(() => {});
  }

  showDatailCalcul(listeConmponent: ListeComponent) {
    if (listeConmponent.row) {
      this.generalService.dialog.open(this.frmCalcul);
      this.generalService.dialog.afterAllClosed.subscribe(() => {
        this.detailJourCout = [];
        this.EventCalculated = false;
      });
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une ligne',
        false
      );
  }

  verifierLists(list1, list2) {
    var TravD = list1.map(function (obj) {
      return obj.TravelD_Pos;
    });
    console.log(TravD);

    var resCalc = list2.slice(0, list2.length - 1).map(function (obj) {
      return obj.TravelD_Pos;
    });
    console.log(resCalc);

    const isSubset = (array1, array2) =>
      array2.every((element) => array1.includes(element));

    console.log(TravD.filter((e) => e != resCalc.find(e)));

    console.log(isSubset(resCalc, TravD));
    var ALLexist = isSubset(resCalc, TravD);
    return ALLexist;
  }

  deleteListfromlist(List, listsupp) {
    listsupp.forEach((e1) => {
      if (List.find((e2) => e2 == e1)) {
        this.remove(List, e1);
      }
    });
    return List;
  }

  ListCalculModif;
  listTravelDToVerifyError = [];

  listCalculSingle = [];
  listCalculSupp = [];
  calculAll(isBraquetCalcul?) {
    console.log(this.dsReservation);
    var resCalcul;
    var exist = false;

    this.generalService
      .rechercheTable2(
        'API_CalculTotal',
        this.dsReservation.Travel[0].Travel_Code
      )
      .subscribe((res: any) => {
        console.log('res', res);
        this.travelPrices = res;
        // this.generalService
        //   .rechercheTable2(
        //     'API_Calcul_Single',
        //     this.dsReservation.Travel[0].Travel_Code
        //   )
        //   .subscribe((SingleData: any) => {
        //     this.listCalculSingle = SingleData;
        //     console.log('this.listCalculSingle', this.listCalculSingle);
        //     this.totalSingle = { ...SingleData[SingleData.length - 1] };
        //     console.log('this.totalSingle', this.totalSingle);
        //   });

        // this.generalService
        //   .rechercheTable2(
        //     'API_Calcul_Supp',
        //     this.dsReservation.Travel[0].Travel_Code
        //   )
        //   .subscribe((SuppData: any) => {
        //     this.listCalculSupp = SuppData;
        //     console.log('this.listCalculSupp', this.listCalculSupp);
        //     this.totalSupplement = { ...SuppData[SuppData.length - 1] };
        //     console.log('this.totalSupplement', this.totalSupplement);
        //   });
        this.generalService
          .rechercheTable2(
            'API_CalculTotalModif',
            this.dsReservation.Travel[0].Travel_Code
          )
          .subscribe((data: any) => {
            console.log('data', data);
            this.refreshList();
            if (data.length == 1) data = res;

            var listManque = [...res].slice(0, res.length - 1);
            console.log(listManque);

            if (this.dsReservation.TravelD.find((e) => e.TravelD_Modif == 1)) {
              data = [...data].slice(0, data.length - 1).concat(res);
            }
            if (!isBraquetCalcul) resCalcul = data;
            else resCalcul = res;
            this.ListCalculModif = resCalcul;
            console.log('---->', resCalcul);
            console.log(data);

            var listTravelDVerified = [];

            this.dsReservation.TravelD.forEach((element) => {
              // console.log(element);
              // resCalcul.filter(e=>e.TravelD_id == element.id).map(e=>{
              //   console.log(e)
              // })
              var findIt = false;

              for (let i = 0; i <= resCalcul.length - 2; i++) {
                if (resCalcul[i]) {
                  if (
                    element.TravelD_Pos == resCalcul[i].TravelD_Pos &&
                    element.TravelD_Jour == resCalcul[i].TravelD_Jour
                  ) {
                    listTravelDVerified.push(element);
                    findIt = true;
                    break;
                  } else if (
                    this.listeEvennement?.find(
                      (e) =>
                        e.evennemtCode == element.TravelD_EventCode &&
                        e.payant == 0
                    )
                  ) {
                    listTravelDVerified.push(element);
                    findIt = true;
                    break;
                  }
                }
              }
              if (!findIt) {
                exist = true;
              }
            });
            console.log('after treatment ---->', resCalcul);
            console.log(exist);
            this.listTravelDToVerifyError = this.deleteListfromlist(
              this.dsReservation.TravelD,
              listTravelDVerified
            );
            console.log('this.totalGlobal', this.totalGlobal);

            console.log(this.listTravelDToVerifyError);
            if (
              !exist ||
              (resCalcul[resCalcul.length - 1]['Prix individuel'] != null &&
                resCalcul[resCalcul.length - 1]['Total indiv'] != null &&
                resCalcul[resCalcul.length - 1]['Total Coll'] != null &&
                resCalcul[resCalcul.length - 1]['Total Supp'] != null) ||
              (!exist &&
                resCalcul[resCalcul.length - 1]['Total indiv'] != null &&
                resCalcul[resCalcul.length - 1]['Total Coll'] != null &&
                resCalcul[resCalcul.length - 1]['Total Supp'] != null)
            ) {
              this.totalGlobal.Pi =
                resCalcul[resCalcul.length - 1]['Prix individuel'];
              this.totalGlobal.Si =
                resCalcul[resCalcul.length - 1]['Total indiv'];
              this.totalGlobal.Sc =
                resCalcul[resCalcul.length - 1]['Total Coll'];
              this.totalGlobal.Ss =
                resCalcul[resCalcul.length - 1]['Total Supp'];
              this.totalGlobal.tva =
                resCalcul[resCalcul.length - 1]['TotalTVA'];
              this.totalGlobal.Total_Single =
                resCalcul[resCalcul.length - 1]['Total Single'];
              this.totalGlobal.Total_Supp =
                resCalcul[resCalcul.length - 1]['Total Supp'];
              this.totalGlobal.frais_staff =
                resCalcul[resCalcul.length - 1]['Total Staff'];
              this.totalGlobal.MargeIndColl =
                resCalcul[resCalcul.length - 1]['Marge IndColl'];
              this.totalGlobal.MargeSingle =
                resCalcul[resCalcul.length - 1]['Marge Single'];
              this.totalGlobal.MargeSupp =
                resCalcul[resCalcul.length - 1]['Marge Supp'];
              this.totalGlobal.Marge_Circuit =
                resCalcul[resCalcul.length - 1]['Marge_Circuit'];
              this.totalGlobal.TVA_Marge =
                resCalcul[resCalcul.length - 1]['TVA_Marge'];
              this.totalGlobal.totalTTC =
                resCalcul[resCalcul.length - 1]['Total'];
              // this.totalGlobal.tva = res[res.length - 1]['TotalTVA'];
              console.log(this.totalGlobal);

              if (
                this.dsReservation.Travel[0].Travel_statut == null ||
                this.dsReservation.Travel[0].Travel_statut < 10
              ) {
                console.log(data);
                if (
                  !this.dsReservation.TravelDM ||
                  this.dsReservation.TravelDM.length == 0
                ) {
                  this.dsReservation.TravelDM = [...resCalcul]
                    .slice(0, resCalcul.length - 1)
                    .map((t) => {
                      return {
                        ...t,
                        TravelDM_Modif: 0,
                        U_timestamp: null,
                        Travel_Code: this.dsReservation.Travel[0].Travel_Code,
                      };
                    });
                  this.dsReservation.Travel[0].Travel_statut = 10;
                  this.dsReservation.TravelD.forEach((day) => {
                    day.TravelD_Modif = 0;
                  });

                  this.reservation.Travel_statut1 = 1;
                  console.log(this.dsReservation);
                  this.enregistrer();
                } else {
                  console.log('calcul jdid');
                  console.log(this.dsReservation.TravelDM);

                  listManque.forEach((mq) => {
                    mq.id = null;
                    mq.TravelDM_Modif = 0;
                    mq.U_timestamp = null;
                    mq.Travel_Code = this.dsReservation.Travel[0].Travel_Code;
                  });
                  console.log(listManque);

                  this.dsReservation.TravelDM = listManque;
                  this.dsReservation.Travel[0].Travel_statut = 10;
                  this.dsReservation.TravelD.forEach((day) => {
                    day.TravelD_Modif = 0;
                  });

                  this.reservation.Travel_statut1 = 1;
                  console.log('this.dsReservation', this.dsReservation);

                  this.enregistrer();
                }
              }
            } else {
              // this.reservation.Travel_statut1=0
              // this.effacerCalcul()
              console.log('resCalcul', resCalcul);
              console.log(
                "resCalcul[resCalcul.length - 1]['Prix individuel'] != null",
                resCalcul[resCalcul.length - 1]['Prix individuel'] != null
              );
              console.log(
                " resCalcul[resCalcul.length - 1]['Total indiv'] != null",
                resCalcul[resCalcul.length - 1]['Total Coll'] != null
              );
              console.log(
                "resCalcul[resCalcul.length - 1]['Total Coll'] != null",
                resCalcul[resCalcul.length - 1]['Total Supp'] != null
              );
              console.log(
                "resCalcul[resCalcul.length - 1]['Total Supp'] != null",
                resCalcul[resCalcul.length - 1]['Total indiv'] != null
              );
              console.log('!exist', !exist);
              console.log(
                "resCalcul[resCalcul.length - 1]['Total indiv'] != null",
                resCalcul[resCalcul.length - 1]['Total indiv'] != null
              );
              console.log(
                "resCalcul[resCalcul.length - 1]['Total Coll'] != null",
                resCalcul[resCalcul.length - 1]['Total Coll'] != null
              );
              console.log(
                "resCalcul[resCalcul.length - 1]['Total Supp'] != null",
                resCalcul[resCalcul.length - 1]['Total Supp'] != null
              );
              this.generalService.dialogSuccess(
                'Veuillez verifier vos données',
                false
              );
            }
          });
      });
  }
  effacerCalcul() {
    if (this.dsReservation.TravelDM[0].id == null) {
      this.dsReservation.Travel[0].Travel_statut = 0;
      this.enregistrer();
    } else {
      const reqs = this.dsReservation.TravelDM.map((e) =>
        this.generalService.delete(e.id, 'TravelDM')
      );
      forkJoin(reqs).subscribe(() => {
        this.dsReservation.TravelDM = [];
        this.dsReservation.Travel[0].Travel_statut = 0;
        this.dsReservation.Travel[0].Travel_statut1 = 0;
        this.totalGlobal = {};
        this.totalSingle = {};
        this.totalSupplement = {};
        this.symboleDev = 'TND';
        this.enregistrer();
      });
    }
  }

  archiverCalcul() {
    if (this.dsReservation) {
      if (this.dsReservation.TravelDM.length == 0) {
        this.dsReservation.Travel[0].Travel_statut = 0;
        this.enregistrer();
      } else {
        this.totalGlobal = {};
        this.totalSingle = {};
        this.totalSupplement = {};
        this.symboleDev = 'TND';
        this.dsReservation.Travel[0].Travel_statut = 0;
        this.enregistrer();
      }
    }
  }

  calculFromBraquetResult() {}

  showVerificationErrorList() {
    this.generalService.dialog.open(this.frmVerifyError, {
      width: '90vw',
      maxWidth: '100vw',
    });
    this.generalService.dialog.afterAllClosed.subscribe(() => {});
  }

  monterDescendre(listeConmponent, index) {
    if (
      listeConmponent.rowIndex - index >= listeConmponent.dataSource.length ||
      listeConmponent.rowIndex - index < 0
    ) {
      return;
    }
    const switchWith = JSON.parse(
      JSON.stringify(
        listeConmponent.dataSource[listeConmponent.rowIndex - index]
      )
    );
    const selectedLine = JSON.parse(
      JSON.stringify(listeConmponent.dataSource[listeConmponent.rowIndex])
    );
    //console.log(selectedLine, switchWith)
    if (index == -1) {
      let aux = selectedLine.TravelD_Pos;
      selectedLine.TravelD_Pos = switchWith.TravelD_Pos;
      switchWith.TravelD_Pos = aux;
      switchWith.TravelD_HDeb = selectedLine.TravelD_HDeb;
      switchWith.TravelD_HFin = this.calculerHeurMonterDesendre(
        switchWith.TravelD_HDeb,
        switchWith.TravelD_Duree
      );
      switchWith.TravelD_HFin = this.calculerHeurMonterDesendre(
        switchWith.TravelD_HFin,
        switchWith.TravelD_DureeTrajet
      );
      let valueReturn = switchWith.TravelD_HFin;
      if (valueReturn.indexOf(':') != -1) {
        selectedLine.TravelD_HDeb = valueReturn;
      } else {
        selectedLine.TravelD_HDeb = switchWith.TravelD_HFin;
      }

      selectedLine.TravelD_HFin = this.calculerHeurMonterDesendre(
        selectedLine.TravelD_HDeb,
        selectedLine.TravelD_Duree
      );
      selectedLine.TravelD_HFin = this.calculerHeurMonterDesendre(
        selectedLine.TravelD_HFin,
        selectedLine.TravelD_DureeTrajet
      );
      console.log('***********');
      console.log(listeConmponent);
      console.log('***********');
      this.orderListeReservationDetail(index);

      //+ switchWith.TravelD_DureeTrajet
    } else if (index == 1) {
      let aux = selectedLine.TravelD_Pos;
      selectedLine.TravelD_Pos = switchWith.TravelD_Pos;
      switchWith.TravelD_Pos = aux;
      selectedLine.TravelD_HDeb = switchWith.TravelD_HDeb;
      selectedLine.TravelD_HFin = this.calculerHeurMonterDesendre(
        selectedLine.TravelD_HDeb,
        selectedLine.TravelD_Duree
      );
      selectedLine.TravelD_HFin = this.calculerHeurMonterDesendre(
        selectedLine.TravelD_HFin,
        selectedLine.TravelD_DureeTrajet
      );
      switchWith.TravelD_HDeb = selectedLine.TravelD_HFin;
      switchWith.TravelD_HFin = this.calculerHeurMonterDesendre(
        switchWith.TravelD_HDeb,
        switchWith.TravelD_Duree
      );
      switchWith.TravelD_HFin = this.calculerHeurMonterDesendre(
        switchWith.TravelD_HFin,
        switchWith.TravelD_DureeTrajet
      );
      console.log('***********');
      console.log(listeConmponent);
      console.log('***********');
    }
    listeConmponent.dataSource[listeConmponent.rowIndex - index] = selectedLine;
    listeConmponent.dataSource[listeConmponent.rowIndex] = switchWith;
    listeConmponent.rowIndex = listeConmponent.rowIndex - index;
    listeConmponent.dataSource = this.SortByHDeb_Generic(
      listeConmponent.dataSource
    );

    clearTimeout(this.saveTimeout);
    this.saveTimeout = setTimeout(() => {
      this.refreshList();
      this.enregistrer_Generic();
    }, 2000);
  }
  calculerHdebWithDureeAfterDesender(heurDeb, duree) {
    var hour = parseInt(heurDeb.split(':')[0]);
    var min = parseInt(heurDeb.split(':')[1]);
    var DureeHour = Math.floor(duree / 60);
    var dureeMin = Math.floor(duree % 60);
    var returnValue = '';
    if (duree > 0) {
      if (min + dureeMin > 59) {
        if (hour + Math.floor((min + dureeMin) / 60) + DureeHour < 24) {
          hour += Math.floor((min + dureeMin) / 60) + DureeHour;
          min = Math.floor((min + dureeMin) % 60);
          returnValue = '' + hour + ':' + min;
        }
        //else
      } else if (min + dureeMin > 59) {
        if (hour + DureeHour < 24) {
          hour += DureeHour;
          min += dureeMin;
          returnValue = '' + hour + ':' + min;
        }
      } else {
        hour += DureeHour;
        min += dureeMin;
        returnValue = '' + hour + ':' + min;
      }
      return returnValue;
    } else {
      return heurDeb;
    }
  }
  changecalculerHeur(TravelD_HDeb, TravelD_Duree) {
    var d = new Date(
      '2000/01/01 ' +
        (TravelD_HDeb.length > 2 ? TravelD_HDeb : TravelD_HDeb + ':00')
    );
    if (typeof TravelD_Duree == 'string') {
      var hour = TravelD_Duree.split(':')[0];
      var min = TravelD_Duree.split(':')[1];
      d.setHours(d.getHours() + parseInt(hour));
      d.setMinutes(d.getMinutes() + parseInt(min));
    } else if (typeof TravelD_Duree == 'number') {
      d.setHours(d.getHours() + Math.floor(TravelD_Duree / 60));
      d.setMinutes(d.getMinutes() + Math.floor(TravelD_Duree % 60));
    }
    return this.dateService.extractTimeFromDate(d);
  }
  calculerHeur(TravelD_HDeb, TravelD_Duree) {
    var d = new Date(
      '2000/01/01 ' +
        (TravelD_HDeb.length > 2 ? TravelD_HDeb : TravelD_HDeb + ':00')
    );
    d.setHours(d.getHours() + parseInt(TravelD_Duree));
    d.setMinutes(d.getMinutes() + parseInt(TravelD_Duree));
    return this.dateService.extractTimeFromDate(d);
  }
  calculerHeurMonterDesendre(TravelD_HDeb, TravelD_Duree) {
    //console.log(TravelD_HDeb, TravelD_Duree)
    var d = new Date(
      '2000/01/01 ' +
        (TravelD_HDeb.length > 2 ? TravelD_HDeb : TravelD_HDeb + ':00')
    );

    d.setHours(d.getHours() + Math.floor(TravelD_Duree / 60));
    d.setMinutes(d.getMinutes() + Math.floor(TravelD_Duree % 60));
    console.log('********', this.dateService.extractTimeFromDate(d));

    return this.dateService.extractTimeFromDate(d);
  }
  dureeStringNumber(duree) {
    //console.log(duree);
    if (typeof duree == 'string') {
      var hour = parseInt(duree.split(':')[0]) * 60;
      var min = parseInt(duree.split(':')[1]);
      return hour + min;
    } else return duree;
  }

  supprimer(event, listeConmponent) {
    console.log(event.liste);

    if (this.generalService.isNotEmpty(event.liste.rowIndex)) {
      const dialogConfig = this.generalService.dialogConfig;
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(
        AvtDialogDeleteComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'supprimer') {
          if (this.mode == '2') {
            if (this.generalService.isNotEmpty(event.liste.row.id)) {
              console.log(event.liste.dataSource.length);
              this.pos =
                event.liste.dataSource[
                  event.liste.dataSource.length - 1
                ].TravelD_Pos;

              var deleteFn = this.generalService.delete(
                event.liste.row.id,
                'TravelD'
              );
              if (deleteFn != null) {
                this.exist = false;
                deleteFn.subscribe(
                  (data) => {
                    listeConmponent.dataSource.splice(
                      listeConmponent.rowIndex,
                      1
                    );

                    console.log();

                    var ListTravelDMtoDelete;
                    if (
                      this.dsReservation.TravelDM ||
                      this.dsReservation.TravelDM.length > 0
                    ) {
                      ListTravelDMtoDelete = this.dsReservation.TravelDM.filter(
                        (e) =>
                          e.TravelD_Jour == event.liste.row.TravelD_Jour &&
                          e.TravelD_Pos == event.liste.row.TravelD_Pos
                      );
                      console.log(ListTravelDMtoDelete);

                      this.dsReservation.TravelDM = this.suppListfromlist(
                        this.dsReservation.TravelDM,
                        ListTravelDMtoDelete
                      );
                    }
                    event.liste.rowIndex = null;

                    if (listeConmponent.dataSource.length > 0) {
                      this.reglageHorair_Generic(
                        listeConmponent.dataSource,
                        listeConmponent.dataSource[0].TravelD_HDeb
                      );
                      listeConmponent.dataSource = this.SortByHDeb_Generic(
                        listeConmponent.dataSource
                      );
                    }
                    this.enregistrer_Generic();
                    //this.refreshList();
                    this.generalService.dialogSuccess(
                      'Elément supprimer',
                      true
                    );
                    this.exist = true;
                    //this.refreshList();
                  },
                  (error) => {
                    this.generalService.dialogSuccess(
                      'Elément non supprimé',
                      false
                    );

                    this.exist = true;
                  }
                );
              }
            }
          }
        }
      });
    }
  }

  supprimerMultiple(event, listeConmponent) {
    console.log(event.liste);

    if (this.generalService.isNotEmpty(event.liste.listSelectedrows)) {
      const dialogConfig = this.generalService.dialogConfig;
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(
        AvtDialogDeleteComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'supprimer') {
          if (this.mode == '2') {
            this.pos =
              event.liste.dataSource[
                event.liste.dataSource.length - 1
              ].TravelD_Pos;

            event.liste.listSelectedrows.forEach((row: any) => {
              var deleteFn = this.generalService.delete(row.id, 'TravelD');
              if (deleteFn != null) {
                this.exist = false;
                deleteFn.subscribe(
                  (data) => {
                    listeConmponent.dataSource.splice(
                      listeConmponent.dataSource.indexOf(row),
                      1
                    );

                    var ListTravelDMtoDelete = [];
                    if (
                      this.dsReservation.TravelDM ||
                      this.dsReservation.TravelDM.length > 0
                    ) {
                      for (let rowSelected of event.liste.listSelectedrows) {
                        const itemTodelet_TravelDM =
                          this.dsReservation.TravelDM.find(
                            (e) =>
                              e.TravelD_Jour == rowSelected.TravelD_Jour &&
                              e.TravelD_Pos == rowSelected.TravelD_Pos
                          );
                        ListTravelDMtoDelete.push(itemTodelet_TravelDM);
                      }

                      this.dsReservation.TravelDM = this.suppListfromlist(
                        this.dsReservation.TravelDM,
                        ListTravelDMtoDelete
                      );
                    }
                    /* event.liste.rowIndex = null;

                    if (listeConmponent.dataSource.length > 0) {
                      this.reglageHorair_Generic(
                        listeConmponent.dataSource,
                        listeConmponent.dataSource[0].TravelD_HDeb
                      );
                      listeConmponent.dataSource = this.SortByHDeb_Generic(
                        listeConmponent.dataSource
                      );
                    }*/
                    this.enregistrer_Generic();
                    //this.refreshList();
                    this.generalService.dialogSuccess(
                      'Elément supprimer',
                      true
                    );
                    this.exist = true;
                    //this.refreshList();
                  },
                  (error) => {
                    this.generalService.dialogSuccess(
                      'Elément non supprimé',
                      false
                    );

                    this.exist = true;
                  }
                );
              }
            });
          }
        }
      });
    }
  }

  supprimerItemError(item) {
    if (item) {
      var deleteFn = this.generalService.delete(item.id, 'TravelD');
      if (deleteFn != null) {
        this.exist = false;
        deleteFn.subscribe(
          (data) => {
            console.log(this.listeConmponent.toArray());
            this.listeConmponent
              .toArray()
              [item.TravelD_Jour - 1].dataSource.splice(
                this.listeConmponent
                  .toArray()
                  [item.TravelD_Jour - 1].dataSource.indexOf(item),
                1
              );
            this.listTravelDToVerifyError.splice(
              this.listTravelDToVerifyError.indexOf(item),
              1
            );

            //this.enregistrer_Generic()
            //this.refreshList();
            this.generalService.dialogSuccess('Elément supprimer', true);
            this.exist = true;

            //this.generalService.dialog.closeAll();
          },
          (error) => {
            this.generalService.dialogSuccess('Elément non supprimé', false);

            this.exist = true;
          }
        );
      }
    }
  }

  supprimerListOfErrors() {
    this.listTravelDToVerifyError.forEach((element) => {
      setTimeout(() => {
        this.supprimerItemError(element);
      }, 500);
    });
  }
  modifActive = false;
  hDeb;
  Heuredureedeb;
  Mindureedeb;
  menuChoixWithPrice;
  modifier(event, mode) {
    if (event.liste.rowIndex == 0) {
      this.modifActive = true;
    } else {
      this.modifActive = false;
    }
    if (this.dsReservation.Travel[0].Travel_statut >= 10) {
      this.generalService.dialogSuccess(
        'veuillez supprimer le calcul pour pouvoir modifier cet événement',
        false
      );
      return;
    }
    if (event && event.liste.row) {
      //console.log(event.liste)
      this.listeOpend = event.liste;
      this.bouton = mode;
      this.reservationD = JSON.parse(JSON.stringify(event.liste.row));
      // this.reservationD.TravelD_Km = Number(
      //   this.reservationD.TravelD_Km.replace(/\D+/g, '')
      // );

      console.log(this.reservationD);
      console.log(this.listeTypeEvennement);

      this.typeEvent = this.reservationD.TravelD_Type;

      var param =
        event.liste.row.TravelD_TypeEvent + ',' + event.liste.row.Tiers_code;
      console.log(param);

      var dateDeb = new Date(
        JSON.stringify(this.dsReservation.Travel[0].Travel_DateDeb).substring(
          1,
          11
        )
      ).toLocaleDateString('fr-CA');
      var Day = parseInt(dateDeb.substring(8, 11));
      var date = new Date(dateDeb).setDate(this.indexJour - 2 + Day);
      var dateJourSelected = new Date(date).toLocaleDateString('fr-CA');

      var param =
        dateJourSelected +
        ',' +
        event.liste.row.Tiers_code +
        ',' +
        this.dsReservation.Travel[0].Travel_NbPerso;

      this.generalService
        .rechercheTable2('API_calculLigneResto', param)
        .subscribe((res: any) => {
          const menuChoix = res.find(
            (e) => e.Type_Tarif == this.reservationD.TravelD_Type
          );
          this.choixMenu = 0;
          this.menuChoixWithPrice = 0;
          console.log(menuChoix);
        });

      if (
        event.liste.row.TravelD_TypeEvent == '0' &&
        event.liste.row.Tiers_code
      ) {
        this.generalService
          .rechercheTable2('Api_listeType', param)
          .subscribe((res) => {
            console.log(res);
            this.listeTypeFiltred = res;
          });
      }
      if (event.liste.row.TravelD_HDeb) {
        var HeureDeb, MinuteDeb;
        HeureDeb = parseInt(event.liste.row.TravelD_HDeb.split(':')[0]);
        MinuteDeb = parseInt(event.liste.row.TravelD_HDeb.split(':')[1]);
        this.hDeb = '' + HeureDeb + ':' + MinuteDeb;
        this.reservationD.TravelD_HDeb = this.hDeb;
        // console.log(this.hDeb,typeof(this.hDeb));
      }
      if (event.liste.row.TravelD_HFin) {
        this.HourFin = parseInt(event.liste.row.TravelD_HFin.split(':')[0]);
        this.MinFin = parseInt(event.liste.row.TravelD_HFin.split(':')[1]);
      }
      if (event.liste.row.TravelD_Duree) {
        if (event.liste.row.TravelD_Duree > 59) {
          let y;
          y = Math.floor(event.liste.row.TravelD_Duree / 60);
          this.Mindureedeb = Math.floor(event.liste.row.TravelD_Duree % 60);
          this.Heuredureedeb = '' + y + ':' + this.Mindureedeb;
          this.reservationD.TravelD_Duree = this.Heuredureedeb;
          // console.log(this.Heuredureedeb);
        } else {
          let y;
          y = 0;
          this.Mindureedeb = event.liste.row.TravelD_Duree;
          this.Heuredureedeb = '' + y + ':' + event.liste.row.TravelD_Duree;
          this.reservationD.TravelD_Duree = this.Heuredureedeb;
          // console.log(this.Heuredureedeb);
        }
      }
      this.typeEvennementChange(event, true);
      var dialog = this.generalService.dialog.open(this.frmAjout, {
        disableClose: true,
      });
      dialog.afterClosed().subscribe(() => {});
    } else
      this.generalService.dialogSuccess(
        'Veillez sélectionner une ligne',
        false
      );
  }
  TravelD_TypeLabel = 'menu';
  ajouter(listeConmponent, TravelD_Jour, mode) {
    this.reservationD = {};
    if (listeConmponent.dataSource.length >= 1) {
      var chaineDeb, hDeb, minDeb;
      if (
        Math.floor(
          listeConmponent.dataSource[listeConmponent.dataSource.length - 1]
            .TravelD_DureeTrajet / 60
        ) >= 1
      ) {
        hDeb = parseInt(
          listeConmponent.dataSource[
            listeConmponent.dataSource.length - 1
          ].TravelD_HFin.split(':')[0]
        );
        minDeb = parseInt(
          listeConmponent.dataSource[
            listeConmponent.dataSource.length - 1
          ].TravelD_HFin.split(':')[1]
        );
        if (
          hDeb +
            Math.floor(
              listeConmponent.dataSource[listeConmponent.dataSource.length - 1]
                .TravelD_DureeTrajet / 60
            ) <
          24
        ) {
          console.log(hDeb);
          console.log(
            Math.floor(
              listeConmponent.dataSource[listeConmponent.dataSource.length - 1]
                .TravelD_DureeTrajet / 60
            )
          );

          let lastHeureFin_CH =
            listeConmponent.dataSource[listeConmponent.dataSource.length - 1]
              .TravelD_HFin;

          let heureDeb_min =
            this.ConvertisseurHoraire_Minute_Generic(lastHeureFin_CH) + 0;
          // listeConmponent.dataSource[listeConmponent.dataSource.length - 1]
          //   .TravelD_DureeTrajet;
          console.log(heureDeb_min);
          console.log(this.ConvertisseurHoraire_Chaine_Genric(heureDeb_min));

          // this.ConvertisseurHoraire_Minute_Generic()
          chaineDeb = this.ConvertisseurHoraire_Chaine_Genric(heureDeb_min);
          //! OLD one :3
          // '' +
          // (hDeb +
          //   Math.floor(
          //     listeConmponent.dataSource[
          //       listeConmponent.dataSource.length - 1
          //     ].TravelD_DureeTrajet / 60
          //   )) +
          // ':' +
          // (minDeb +
          //   Math.floor(
          //     listeConmponent.dataSource[
          //       listeConmponent.dataSource.length - 1
          //     ].TravelD_DureeTrajet % 60
          //   ));
          console.log(chaineDeb);

          this.reservationD.TravelD_HDeb = chaineDeb;
        } else {
          this.reservationD.TravelD_HDeb = '00:00';
          this.generalService.dialogSuccess(
            'Vous avez seuelment 24 heur par jour ',
            false
          );
        }
      } else {
        hDeb = parseInt(
          listeConmponent.dataSource[
            listeConmponent.dataSource.length - 1
          ].TravelD_HFin.split(':')[0]
        );
        minDeb = parseInt(
          listeConmponent.dataSource[
            listeConmponent.dataSource.length - 1
          ].TravelD_HFin.split(':')[1]
        );
        if (
          minDeb +
            listeConmponent.dataSource[listeConmponent.dataSource.length - 1]
              .TravelD_DureeTrajet >
          59
        ) {
          if (
            hDeb +
              Math.floor(
                listeConmponent.dataSource[
                  listeConmponent.dataSource.length - 1
                ].TravelD_DureeTrajet / 60
              ) <
            24
          ) {
            hDeb += Math.floor((minDeb + 0) / 60);
            minDeb = Math.floor((minDeb + 0) % 60);
            this.reservationD.TravelD_HDeb = '' + hDeb + ':' + minDeb;
          } else {
            this.reservationD.TravelD_HDeb = '00:00';
            this.generalService.dialogSuccess(
              'Vous avez seuelment 24 heur par jour ',
              false
            );
          }
        } else {
          this.reservationD.TravelD_HDeb = '' + hDeb + ':' + (minDeb + 0);
          // Math.floor(
          //   listeConmponent.dataSource[
          //     listeConmponent.dataSource.length - 1
          //   ].TravelD_DureeTrajet
          // )
        }
      }
    } else {
      this.reservationD.TravelD_HDeb = 0;
    }
    this.MinFin = 0;
    this.HourFin = 0;
    this.reservationD.TravelD_Duree = 0;
    this.bouton = mode;
    this.TravelD_Jour = TravelD_Jour;
    this.reservationD.TravelD_TypeEvent = 0;
    this.reservationD.TravelD_DureeTrajet = 0;
    this.reservationD.TravelD_Km = 0;
    this.typeEvennementChange();
    this.index = listeConmponent.index;

    if (listeConmponent.dataSource.length > 0) {
      const lastLine =
        this.listeConmponent.toArray()[this.index].dataSource[
          this.listeConmponent.toArray()[this.index].dataSource.length - 1
        ];
    }
    //   this.reservationD.TravelD_HDeb = this.calculerHeur(
    //     lastLine.TravelD_HFin,
    //     lastLine.TravelD_DureeTrajet
    //   );
    // }
    this.generalService.dialog.open(this.frmAjout, {
      disableClose: true,
    });
    this.orderListeReservationDetail(TravelD_Jour);
  }
  genererListeReservationD() {
    this.listeReservationDetail = [];
    if (this.generalService.isNotEmpty(this.reservation.Travel_NbJour))
      for (var i = 0; i < Number(this.reservation.Travel_NbJour) + 1; i++) {
        this.listeReservationDetail.push({
          liste: [],
        });
      }
  }
  sort(liste) {
    liste.sort((a, b) => {
      const bandA = a.date.getTime();
      const bandB = b.date.getTime();
      let comparison = 0;
      if (bandA > bandB) comparison = 1;
      else if (bandA < bandB) comparison = -1;
      return comparison;
    });
    return liste;
  }
  removeAttribut(listeReservationD) {
    for (var i = 0; i < listeReservationD.length; i++) {
      delete listeReservationD[i].typeEvennementText;
      delete listeReservationD[i].typeText;
    }
    return listeReservationD;
  }

  enregist = false;
  enregistrer_Generic() {
    this.exist = false;
    var liste = [];
    var listeReservationD = JSON.parse(
      JSON.stringify(this.listeReservationDetail)
    );

    listeReservationD.forEach((reservationD) => {
      var lst = this.removeAttribut(reservationD.liste);
      lst.forEach((l) => {
        liste.push(l);
      });
    });
    this.dsReservation.TravelD = liste;
    this.dsReservation.TravelDM = this.dsReservation.TravelDM.filter(
      (e) => e.TravelD_Jour != null && e.TravelD_Pos != null
    );

    if (this.mode == '1') {
      this.generateTravel_Ref(this.dsReservation.Travel[0].Tiers_code);
      this.dsReservation.Travel[0].Travel_statut1 = 0;
    }

    if (!this.dsReservation.Travel[0].Travel_GroupID)
      this.dsReservation.Travel[0].Travel_GroupID = new Date()
        .getTime()
        .toString();

    // console.log(this.dsReservation);

    this.generalService.enregisterTable(this.dsReservation).subscribe(
      (data) => {
        this.generalService.dialogSuccess('Enregistré', true);
        this.mode = '2';
        this.getDsReservation(this.dsReservation.Travel[0].Travel_Code);
        //this.tryDeleteReservation();
        this.listeReservationDetail = [];
        this.generalService.dialog.closeAll();
        this.enregist = true;
        for (let i = 1; i <= this.listeReservationDetail.length; i++) {
          this.orderListeReservationDetail(i);
        }
      },
      () => {
        this.exist = true;
        this.generalService.dialogSuccess('Non enregistré', false);
        // this.refreshList();
      }
    );
  }
  enregistrer() {
    var Travel_DateDeb = new Date(this.reservation.Travel_DateDeb);
    var depar = new Date(this.reservation.Travel_DateFin);
    console.log(Travel_DateDeb);
    console.log(depar);
    console.log(Travel_DateDeb <= depar);

    if (Travel_DateDeb > depar) {
      this.generalService.dialogSuccess(
        'La date de début ne peut pas être supérieure à la date de fin',
        false
      );
      return;
    } else if (Travel_DateDeb <= depar) {
      this.exist = false;
      var liste = [];
      var listeReservationD = JSON.parse(
        JSON.stringify(this.listeReservationDetail)
      );

      listeReservationD.forEach((reservationD) => {
        var lst = this.removeAttribut(reservationD.liste);
        lst.forEach((l) => {
          liste.push(l);
        });
      });
      this.dsReservation.TravelD = liste;
      this.dsReservation.TravelDM = this.dsReservation.TravelDM.filter(
        (e) => e.TravelD_Jour != null && e.TravelD_Pos != null
      );

      if (this.mode == '1') {
        this.generateTravel_Ref(this.dsReservation.Travel[0].Tiers_code);
        this.dsReservation.Travel[0].Travel_statut1 = 0;
      }
      if (!this.dsReservation.Travel[0].Travel_GroupID)
        this.dsReservation.Travel[0].Travel_GroupID = new Date()
          .getTime()
          .toString();

      this.dsReservation.TravelD = this.moveNullIdToEnd(
        this.dsReservation.TravelD
      );
      this.generalService.enregisterTable(this.dsReservation).subscribe(
        async (data) => {
          this.generalService.dialogSuccess('Enregistré', true);
          this.mode = '2';
          this.listeReservationDetail = [];
          await this.delay(300);
          this.getDsReservation(this.dsReservation.Travel[0].Travel_Code);
          this.tryDeleteReservation();
          this.generalService.dialog.closeAll();
          //this.refreshList();
          this.enregist = true;
          for (let i = 1; i <= this.listeReservationDetail.length; i++) {
            this.orderListeReservationDetail(i);
          }
        },
        (error) => {
          this.exist = true;
          this.generalService.dialogSuccess('Non enregistré', false);
          console.log(error);
          //this.refreshList();
        }
      );
    }
  }

  moveNullIdToEnd(list) {
    let nullIdElements = list.filter((element) => element.id === null);
    let nonNullIdElements = list.filter((element) => element.id !== null);
    return nonNullIdElements.concat(nullIdElements);
  }

  isTravelDataModified(originalData, newTravelData): boolean {
    const originalTravelData = originalData;
    for (const attribute in newTravelData) {
      if (
        attribute !== 'Travel_Commentaire' &&
        newTravelData[attribute] !== originalTravelData[attribute]
      ) {
        return true;
      }
    }
    return false;
  }

  updateTravel_commentaire(dsReservation) {
    if (
      !this.isTravelDataModified(this.OriginalTarvel, dsReservation.Travel[0])
    ) {
      this.enregistrer();
      this.generalService.dialogSuccess('Commentaire enregistré', true);
    } else {
      this.generalService.dialogSuccess(
        "Non enregistré ! Vous ne pouvez modifier l'en-tête que le commentaire.",
        false
      );
    }
  }

  tryDeleteReservation() {
    this.dsReservationInit.TravelD.forEach((reservation) => {
      if (
        this.dsReservation.TravelD.find((reservationD) => {
          return reservationD.id == reservation.id;
        }) == undefined
      )
        this.generalService
          .delete(reservation.id, 'TravelD')
          .subscribe(() => {});
    });
  }
  init() {
    if (this.mode == '3') this.disabled = true;
    this.getDsReservation(this.travelCode);
  }
  deleteJour(myReservationD) {
    const dialogConfig = this.generalService.dialogConfig;
    dialogConfig.autoFocus = true;
    var dialogRef = this.generalService.dialog.open(
      AvtDialogDeleteComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'supprimer') {
        var listeReservationDToDelete = [];
        if (myReservationD.liste.length > 0)
          listeReservationDToDelete = this.dsReservation.TravelD.filter(
            (reservationD) => {
              return (
                reservationD.TravelD_Jour ==
                myReservationD.liste[0].TravelD_Jour
              );
            }
          );
        listeReservationDToDelete.forEach((reservationD) => {
          var deleteFn = this.generalService.delete(reservationD.id, 'TravelD');
          if (deleteFn != null) {
            this.exist = false;
            deleteFn.subscribe(
              (data) => {
                this.generalService.dialogSuccess('Elément supprimer', true);
                this.exist = true;
              },
              (error) => {
                this.generalService.dialogSuccess(
                  'Elément non supprimé',
                  false
                );
                this.exist = true;
              }
            );
          }
        });
        var listeReservationDToUpdate = [];
        if (this.dsReservation.Travel[0].Travel_NbJour > 1)
          listeReservationDToUpdate = this.dsReservation.TravelD.filter(
            (reservationD) => {
              return (
                reservationD.TravelD_Jour ==
                this.dsReservation.Travel[0].Travel_NbJour
              );
            }
          );
        listeReservationDToUpdate.forEach((reservationD) => {
          reservationD.TravelD_Jour = reservationD.TravelD_Jour - 1;
        });
        if (this.dsReservation.Travel[0].Travel_NbJour >= 1)
          this.dsReservation.Travel[0].Travel_NbJour--;
        this.generalService
          .enregisterTable(this.dsReservation)
          .subscribe((data) => {
            this.getDsReservation(this.dsReservation.Travel[0].Travel_Code);
            this.listeReservationDetail = [];
          });
      }
      if (result == 'annuler') {
      }
    });
  }
  villeBlur(event) {
    this.filterdVille = this.listeVille.slice();
    if (
      this.generalService.isNotEmpty(event.target.value) &&
      this.filterdVille.length > 0 &&
      this.filterdVille.find((time) => {
        return time == event.target.value;
      }) == undefined
    ) {
      event.target.value = this.filterdVille[0];
    }
    this.reservationD.TravelD_Ville = event.target.value;
  }

  villeChange(event) {
    if (this.generalService.isNotEmpty(event.target.value)) {
      this.filterdVille = this.listeVille.filter((val: string) => {
        return val.toLowerCase().indexOf(event.target.value.toLowerCase()) >= 0;
      });
      if (this.filterdVille.length == 0)
        event.target.value = event.target.value.substr(
          0,
          event.target.value.length - 1
        );
    } else this.filterdVille = this.listeVille.slice();
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.travelCode = params['param'];
      this.mode = params['mode'];

      setTimeout(() => {
        this.init();
      }, 500);
    });
  }
  calculerEvent() {
    this.generalService
      .rechercheTable('API_calcul_cout', this.selectedEvent)
      .subscribe((res) => {
        this.detailJourCout = res;
        this.detailJourCout.forEach((element) => {
          element.TravelDM_Coll_Modif = null;
          element.TravelDM_Supp_Modif = null;
          element.TravelDM_Tarif_Modif = null;
          element.id = this.selectedEvent;
        });
        if (res.length == 0)
          this.generalService.dialogSuccess('Pas de calcul', false);
      });
  }

  saveEvent() {
    console.log(this.detailJourCout);
    console.log(this.ListCalculModif);
    this.detailJourCout.forEach((element) => {
      this.ListCalculModif.filter((c) => c.TravelDM_id == element.id).map(
        (c) => {
          this.dsReservation.TravelDM.filter((e) => e.id == element.id).map(
            (e) => {
              if (e.TravelDM_SUPP == 0) {
                e.TravelDM_AccompModif = element.TravelDM_AccompModif;
                e.TravelDM_guideModif = element.TravelDM_guideModif;
                e.TravelDM_ChauffeurModif = element.TravelDM_ChauffeurModif;
                e.TravelDM_Coll_Modif = c.TravelDM_Total_COLL;
                e.TravelDM_Total_INDModif = c.TravelDM_Total_IND;
                // e.TravelDM_margeModif = element.TravelDM_margeModif
                e.TravelDM_Tarif_Modif = element.TravelDM_Tarif_Modif;

                if (
                  element.TravelDM_AccompModif ||
                  element.TravelDM_AccompModif == 0 ||
                  element.TravelDM_AccompModif == '0' ||
                  element.TravelDM_guideModif ||
                  element.TravelDM_guideModif == 0 ||
                  element.TravelDM_guideModif == '0' ||
                  element.TravelDM_ChauffeurModif ||
                  element.TravelDM_ChauffeurModif == 0 ||
                  element.TravelDM_ChauffeurModif == '0' ||
                  element.TravelDM_Coll_Modif ||
                  element.TravelDM_Coll_Modif == 0 ||
                  element.TravelDM_Coll_Modif == '0' ||
                  element.TravelDM_Tarif_Modif ||
                  element.TravelDM_Tarif_Modif == 0 ||
                  element.TravelDM_Tarif_Modif == '0'
                ) {
                  e.TravelDM_Modif = element.TravelDM_Modif = 1;
                  e.TravelDM_AccompModif = !element.TravelDM_AccompModif
                    ? element.TravelDM_Accompagniant
                    : element.TravelDM_AccompModif;
                  //e.TravelDM_AccompModif=element.TravelDM_Accompagniant=element.TravelDM_AccompModif
                  e.TravelDM_guideModif = !element.TravelDM_guideModif
                    ? element.TravelDM_guide
                    : element.TravelDM_guideModif;
                  //e.TravelDM_guideModif=element.TravelDM_guide
                  e.TravelDM_ChauffeurModif = !element.TravelDM_ChauffeurModif
                    ? element.TravelDM_Chauffeur
                    : element.TravelDM_ChauffeurModif;
                  //e.TravelDM_ChauffeurModif=element.TravelDM_Chauffeur
                  //e.TravelDM_Coll_Modif = (!element.TravelDM_Coll_Modif) ? element.TravelDM_Total_COLL : element.TravelDM_Coll_Modif
                  e.TravelDM_Coll_Modif = c.TravelDM_Total_COLL;
                  e.TravelDM_Total_INDModif = c.TravelDM_Total_IND;
                  // e.TravelDM_margeModif = (!element.TravelDM_margeModif) ? element.TravelDM_Marge : element.TravelDM_margeModif
                  //e.TravelDM_margeModif = element.TravelDM_Marge
                  e.TravelDM_Tarif_Modif = !element.TravelDM_Tarif_Modif
                    ? element.TravelDM_Tarif
                    : element.TravelDM_Tarif_Modif;
                } else {
                  e.TravelDM_Modif = element.TravelDM_Modif = 0;
                }
              } else {
                e.TravelDM_Supp_Modif = element.TravelDM_Supp_Modif;
                // e.TravelDM_margeModif = element.TravelDM_margeModif
                if (
                  element.TravelDM_Supp_Modif ||
                  element.TravelDM_margeModif
                ) {
                  e.TravelDM_Modif = element.TravelDM_Modif = 1;
                  e.TravelDM_Supp_Modif = !element.TravelDM_Supp_Modif
                    ? element.TravelDM_SUPP
                    : element.TravelDM_Supp_Modif;
                  // e.TravelDM_margeModif = (!element.TravelDM_margeModif) ? element.TravelDM_Marge : element.TravelDM_margeModif
                } else e.TravelDM_Modif = element.TravelDM_Modif = 0;
              }
            }
          );
        }
      );
    });

    setTimeout(() => {
      this.calculAll();

      this.enregistrer_Generic();
    }, 500);

    console.log(this.ListCalculModif);
  }
  getTotalInfos(key1, key2) {
    const tbClone = JSON.parse(JSON.stringify(this.detailJourCout));

    return tbClone.reduce((a, b) => {
      const val = b[key1] || b[key1] == 0 ? b[key1] : b[key2];
      return (a || 0) + (val || 0);
    }, 0);
  }

  getTotalIndividuel() {
    const tbClone = JSON.parse(JSON.stringify(this.detailJourCout));

    return tbClone.reduce((a, b) => {
      // if (b.TravelDM_Tarif_Modif) b.TravelDM_Total_IND = b.TravelDM_Tarif_Modif;
      // else b.TravelDM_Total_IND = b.TravelDM_Tarif;
      // return (a || 0) + (b['TravelDM_Total_IND'] || 0);
      return (a || 0) + (b['TravelDM_Total_IND'] || 0);
    }, 0);
  }
  getTotalMargeSupp() {
    const tbClone = JSON.parse(JSON.stringify(this.ListSupp));

    return tbClone
      .filter((e) => e.TravelDM_SUPP != 0)
      .reduce((a, b) => {
        return (a || 0) + (b['TravelDM_Marge'] || 0);
      }, 0);
  }
  getTotalMargeSuppSingle() {
    const tbClone = JSON.parse(JSON.stringify(this.ListSuppSingle));

    return tbClone
      .filter((e) => e.TravelDM_SUPP != 0)
      .reduce((a, b) => {
        return (a || 0) + (b['TravelDM_Marge'] || 0);
      }, 0);
  }

  async SetUpImpressionTablePreview() {
    console.log(this.listeReservationDetail);
    const promises = [];
    this.TableImpressionPreview = this.listeReservationDetail.map(
      (jour, index) => {
        return {
          indexJour: index + 1,
          jour: jour.liste.map((event) => {
            const promise = new Promise<void>((resolve, reject) => {
              this.generalService
                .rechercheTable(
                  'API_import_calcul',
                  event.TravelD_Pos +
                    ',' +
                    event.TravelD_Jour +
                    ',' +
                    event.Travel_Code
                )
                .subscribe(
                  (res) => {
                    event.TarifEvent = res;
                    resolve();
                  },
                  (error) => {
                    console.error(error);
                    reject(error);
                  }
                );
            });
            promises.push(promise);
            return { event, TarifEvent: null };
          }),
        };
      }
    );

    await Promise.all(promises);

    this.TableImpressionPreview = this.TableImpressionPreview.map((jour) => {
      jour.jour = jour.jour.map((event) => {
        event.TarifEvent = event.event.TarifEvent;
        return event;
      });
      return jour;
    });
    console.log(this.TableImpressionPreview);

    this.generalService.dialog.open(this.frmImpressionPreview, {
      width: '90vw',
      maxWidth: '100vw',
      maxHeight: '98vh',
    });
    this.generalService.dialog.afterAllClosed.subscribe(() => {
      this.TableImpressionPreview = [];
    });
  }

  get_trajet_ville(inputList: any[]) {
    const groupedCities: any[] = [];
    const dateList: Date[] = [];
    const currentDate = new Date(this.dsReservation.Travel[0].Travel_DateDeb);
    for (const [index, item] of inputList.entries()) {
      const uniqueCities: Set<string> = new Set();
      const uniqueCitiesArray: string[] = [];

      for (const villeObj of item.liste) {
        uniqueCities.add(villeObj.TravelD_Ville);
      }

      uniqueCities.forEach((city) => uniqueCitiesArray.push(city));
      item.visited_cities = uniqueCitiesArray;

      if (index > 0) {
        item.visited_date = new Date(currentDate);
        currentDate.setDate(currentDate.getDate() + 1);
      }
    }
  }

  getRangeDate_Circuits() {
    const dateList: Date[] = [];
    const currentDate = new Date(this.dsReservation.Travel[0].Travel_DateDeb);

    while (
      currentDate <= new Date(this.dsReservation.Travel[0].Travel_DateFin)
    ) {
      dateList.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    console.log(dateList);
    return dateList;
  }
  openPreviewsRapports() {
    this.get_trajet_ville(this.listeReservationDetail);
    console.log(this.listeReservationDetail);

    this.generalService.dialog.open(this.frmImpressionPreview, {
      width: '90vw',
      maxWidth: '100vw',
      maxHeight: '98vh',
    });
    this.generalService.dialog.afterAllClosed.subscribe(() => {
      this.TableImpressionPreview = [];
    });
  }
  isTarifRapport = false;
  SetUpImpressionTablePreviewEtatTarifs() {
    this.isTarifRapport = true;
    const tableFlatten = this.listeReservationDetail.reduce(
      (acc, item) => acc.concat(item.liste),
      []
    );
    console.log(tableFlatten);
    const groupedArray = tableFlatten.reduce((result, item) => {
      const index = result.findIndex(
        (group) => group.TravelD_TypeEvent === item.TravelD_TypeEvent
      );
      if (index === -1) {
        result.push({
          TravelD_TypeEvent: item.TravelD_TypeEvent,
          typeEvennementText: item.typeEvennementText,
          events: [item],
        });
      } else {
        result[index].events.push(item);
      }
      return result;
    }, []);

    // Create an array of promises for each API request
    const promises = [];
    groupedArray.forEach((group) => {
      group.events.forEach((item) => {
        const promise = this.generalService
          .rechercheTable(
            'API_import_calcul',
            item.TravelD_Pos + ',' + item.TravelD_Jour + ',' + item.Travel_Code
          )
          .toPromise()
          .then((res) => {
            console.log(res.length);
            item.tarifs = res;
          });
        promises.push(promise);
      });
    });

    // Wait for all promises to complete before filtering the array
    Promise.all(promises).then(() => {
      console.log(groupedArray);

      const filteredArray = groupedArray.filter((group) => {
        return group.events.some((item) => {
          return item.tarifs && item.tarifs.length > 0;
        });
      });

      console.log(filteredArray);

      this.TableImpressionPreview = filteredArray;
      // this.generalService.dialog.open(this.frmImpressionPreview, { width: '90vw', maxWidth: '100vw', maxHeight:'98vh' });
      // this.generalService.dialog.afterAllClosed.subscribe(() => {
      //   this.TableImpressionPreview=[]
      //   });
    });
  }

  prixTotalDevInit;
  TarifSupp;
  calculPrix(total, marge) {
    if (!marge) {
      marge = 1;
      this.prixTotalDevInit = total * marge;

      return total * marge;
    } else {
      this.prixTotalDevInit = total * (1 + marge / 100);
      return total * (1 + marge / 100);
    }
  }

  saveTauxMarge(marge) {
    this.reservation.Travel_Marge = marge;
    this.updateDs();
  }

  saveTauxTVA(TauxTva) {
    this.reservation.Travel_TVA = TauxTva;
    this.updateDs();
  }

  saveTauxMargeTravelDM(idRow, marge) {
    console.log(this.ListSupp);

    if (marge)
      this.dsReservation.TravelDM.find(
        (e) => e.id == idRow
      ).TravelDM_margeModif = marge;
    console.log(this.dsReservation.TravelDM);
    this.updateDs();
    this.calculerTotals();
  }

  calculerTotals() {
    this.detailCoutSupp = this.ListSupp.reduce((a, b) => {
      if (!b.TravelDM_Supp_Modif || b.TravelDM_Supp_Modif == 0)
        return (a || 0) + (b.TravelDM_SUPP || 0) + (b.TravelDM_Marge || 0);
      else
        return (
          (a || 0) + (b.TravelDM_Supp_Modif || 0) + (b.TravelDM_Marge || 0)
        );
    }, 0);

    this.TotalSuppDevise = this.detailCout.reduce((a, b) => {
      if (!b.TravelDM_Supp_Modif || b.TravelDM_Supp_Modif == 0)
        return (a || 0) + (b.TravelDM_SUPP / this.coef || 0);
      else return (a || 0) + (b.TravelDM_Supp_Modif / this.coef || 0);
    }, 0);

    this.TotalSuppSingle = this.ListSuppSingle.reduce((a, b) => {
      if (!b.TravelDM_Supp_Modif || b.TravelDM_Supp_Modif == 0)
        return (a || 0) + (b.TravelDM_SUPP || 0) + (b.TravelDM_Marge || 0);
      else
        return (
          (a || 0) + (b.TravelDM_Supp_Modif || 0) + (b.TravelDM_Marge || 0)
        );
    }, 0);
  }

  updateDs() {
    this.generalService.enregisterTable(this.dsReservation).subscribe(
      (data) => {
        this.generalService.dialogSuccess('Enregistré', true);
        this.fetchDsReservation(this.dsReservation.Travel[0].Travel_Code);
        this.tryDeleteReservation();
        this.listeReservationDetail = [];

        this.refreshList();
        for (let i = 1; i <= this.listeReservationDetail.length; i++) {
          this.orderListeReservationDetail(i);
        }
      },
      () => {
        this.generalService.dialogSuccess('Non enregistré', false);
        this.refreshList();
      }
    );
  }

  setUpGlobalValues() {
    this.generalService
      .rechercheTable2('Api_listeTypeEvennement')
      .subscribe((res) => {
        this.listeTypeEvennement = res;
      });
    this.generalService
      .rechercheTable2('Api_listeEvennement')
      .subscribe((res) => {
        this.listeEvennement = res;
        console.log(res);
      });

    this.generalService.rechercheTable2('Api_listeType').subscribe((res) => {
      this.listeType = res;
      console.log(res);
    });
  }
  refreshinge = false;
  refresh() {
    //this.refreshinge = true;
    setTimeout(() => {
      //this.refreshinge = false;
    }, 1000);
  }
  async refreshList() {
    // ? toggle vsibility so the ui refreshes
    //this.refreshing = true;
    setTimeout(() => {
      // this.refreshing = false;
      this.listeReservationDetail.forEach((e) => {
        e.liste = this.SortByHDeb_Generic(e.liste);
      });
      //console.log(this.listeReservationDetail)
    }, 700);
  }
  updateDuree() {
    const dFin = new Date(
      '2000/01/01 ' +
        (this.reservationD.TravelD_HFin.length > 2
          ? this.reservationD.TravelD_HFin
          : this.reservationD.TravelD_HFin + ':00')
    );
    const dDeb = new Date(
      '2000/01/01 ' +
        (this.reservationD.TravelD_HDeb.length > 2
          ? this.reservationD.TravelD_HDeb
          : this.reservationD.TravelD_HDeb + ':00')
    );
    const Minutes = Math.round(
      ((dFin.getTime() - (dDeb.getTime() % 86400000)) % 3600000) / 60000
    );
    this.reservationD.TravelD_Duree = Minutes;
  }
  filterdTimeWithMin() {
    return this.filterdTime.slice(
      this.filterdTime.indexOf(this.reservationD.TravelD_HDeb),
      this.filterdTime.length
    );
  }
  async genererDocuments() {
    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
    let i = 0;
    for (const e of this.dsReservation.TravelD) {
      const document = [
        {
          Doc_Num: '',
          Tiers_code: e.Tiers_code,
          Doc_Type: 'CMD',
          Doc_Param1: this.dsReservation.Travel[0].Travel_Code,
          Doc_Param2: this.reservation.Travel_Nom,
        },
      ];

      var documentD = [
        {
          Doc_Num: '',
          DocD_Id: '',
          Art_Code: this.listeEvennement.find(
            (k) => k.TravelD_Event == e.TravelD_Event
          ).evennemtCode,
          DocD_Q: this.reservation.Travel_NbPerso,
          DocD_THT: this.totalGlobal.Sc + this.totalGlobal.Si,
        },
      ];
      var ds = {
        Document: document,
        DocumentD: documentD,
        ApiParam: [{ androidId: 123 }],
      };
      try {
        const r = await this.generalService.saveDA(ds).toPromise();

        await sleep(1000);
      } catch (error) {}

      if (i == this.dsReservation.TravelD.length - 1) {
        this.dsReservation.Travel[0].Travel_statut = 20;
        this.enregistrer();
        this.generalService.dialogSuccess(
          'Document Enregistrer avec success ! ',
          true
        );
      }
      i++;
    }
  }

  async deblockCircuit() {
    this.dsReservation.Travel[0].Travel_statut = 10;
    this.enregistrer();
    this.generalService.dialogSuccess(
      'Document débloqué avec success ! ',
      true
    );
  }

  //Get value selected of Type Travel
  changeTypTravel(value) {
    // console.log(value);
    this.dsReservation.Travel[0].Travel_Type = value;
  }

  //Get value selected of Type Travel
  changeSaison(value) {
    this.dsReservation.Travel[0].Travel_Saison = value;
    // console.log(value);
  }

  //Get value selected of Client
  changeClient(value) {
    // console.log(value);
  }

  //generate Travel_ref
  generateTravel_Ref(code_client: string) {
    let ref_typTrav;
    let ref_Saison;

    if (
      !this.dsReservation.Travel[0].Travel_Type ||
      !this.dsReservation.Travel[0].Travel_Saison ||
      !code_client ||
      !this.dsReservation.Travel[0].Travel_DateFin
    ) {
      this.dsReservation.Travel[0].Travel_Ref = 'pas de référence';
    } else {
      console.log(this.dsReservation.Travel[0].Travel_DateFin);

      const ref_Year = new Date(this.dsReservation.Travel[0].Travel_DateFin)
        .getFullYear()
        .toString()
        .substring(2);

      ref_typTrav =
        this.dsReservation.Travel[0].Travel_Type == 'ponctuel' ? 'GA' : 'GS';
      ref_Saison =
        this.dsReservation.Travel[0].Travel_Saison == 'summer' ? 'S' : 'W';

      this.dsReservation.Travel[0].Travel_Ref =
        ref_Year + ref_typTrav + '-' + code_client + '-' + ref_Saison;
    }
  }

  //methode device
  montant;
  totalGlobal2;
  symboleDev = 'TND';
  selectDevise(dev) {
    this.totalGlobal2 = {};
    var coef;
    //get coeficient devise
    this.generalService
      .rechercheTable('API_CoeffDevise', dev)
      .subscribe((res) => {
        let devise = res;
        // console.log(this.ListeSymbolDevive);

        this.ListeSymbolDevive.forEach((symb) => {
          if (devise[0].Devise_Code == symb.DevCde) devise.push(symb.DevSymb);
        });

        // console.log(devise);

        this.montant = devise[0].Devise_Cours;
        this.symboleDev = devise[1];

        var url = 'ds/formdata?code=Travel';

        if (this.mode == '2' || this.mode == '3')
          url += '&val=' + this.dsReservation.Travel[0].Travel_Code;
        this.generalService.rechercheTable(url).subscribe((data) => {
          this.dsReservation = data;
          // console.log(this.dsReservation);

          this.generalService
            .rechercheTable2(
              'API_CalculTotalModif',
              this.dsReservation.Travel[0].Travel_Code
            )
            .subscribe((res: any) => {
              // TODO:

              this.totalGlobal.Pi =
                res[res.length - 1]['Prix individuel'] / this.montant;
              this.totalGlobal.Si =
                res[res.length - 1]['Total indiv'] / this.montant;
              this.totalGlobal.Sc =
                res[res.length - 1]['Total Coll'] / this.montant;
              this.totalGlobal.Ss =
                res[res.length - 1]['Total Supp'] / this.montant;
              this.totalGlobal.tva =
                res[res.length - 1]['TotalTVA'] / this.montant;
              this.totalGlobal.totalTTC =
                res[res.length - 1]['Total'] / this.montant;
            });
        });
      });
  }

  coef = 1;
  prixTotalDev;
  prixTotalDevunitaire;
  symbolDevCalcul;
  margeSupp;
  TarifDev;
  selectDeviseCalcul(dev) {
    this.generalService
      .rechercheTable('API_CoeffDevise', dev)
      .subscribe((res) => {
        let devise = res;
        console.log(this.ListeSymbolDevive);
        this.ListeSymbolDevive.forEach((symb) => {
          if (devise[0].Devise_Code == symb.DevCde) devise.push(symb.DevSymb);
        });

        console.log(devise);

        this.coef = devise[0].Devise_Cours;
        this.symbolDevCalcul = devise[1];
        this.prixTotalDev = (this.prixTotalDevInit / this.coef).toFixed(3);
        this.prixTotalDevunitaire = (
          this.prixTotalDev / this.reservation.Travel_NbPerso
        ).toFixed(3);

        this.TarifDev = (this.TarifSupp / this.coef).toFixed(3);
      });
  }

  convertCalcul(coef) {
    console.log(this.prixTotalDev);
    try {
      this.prixTotalDev = (this.prixTotalDevInit / coef).toFixed(3);
      this.prixTotalDevunitaire = (
        this.prixTotalDev / this.reservation.Travel_NbPerso
      ).toFixed(3);
    } catch (e) {
      this.prixTotalDev = this.prixTotalDevInit.toFixed(3);
      this.prixTotalDevunitaire = (
        this.prixTotalDev / this.reservation.Travel_NbPerso
      ).toFixed(3);
    }
  }

  openDialogueAlertDup() {
    this.generalService.dialog.open(this.frmAlertDup, {
      width: '35vw',
      height: '30vh',
      disableClose: true,
    });
  }

  //dupliquer le circuit apres enregistrement
  TravelToCoppy;
  dupliquerCircuit2() {
    this.route.params.subscribe((params) => {
      var travelCode = params['param'];
      this.mode = params['mode'];

      if (this.mode == 1) {
        console.log(this.dsReservation.Travel[0].Travel_Code);
        travelCode = this.dsReservation.Travel[0].Travel_Code;
      }

      console.log(travelCode);
      this.generalService.getDS('Travel', travelCode).subscribe((res) => {
        console.log(res);
        this.TravelToCoppy = res;
        const ApiForm = this.TravelToCoppy.ApiForm[0];
        const Travel = this.TravelToCoppy.Travel[0];
        const TravelD = this.TravelToCoppy.TravelD;
        const TravelDM = this.TravelToCoppy.TravelDM;
        let lastversion;
        this.generalService
          .rechercheTable('API_Version', Travel.Travel_GroupID)
          .subscribe(
            (LastVersion) => {
              lastversion = LastVersion[0].Expr1;
              console.log(lastversion);

              var newTravelCode = new Date().getTime().toString();

              ApiForm.For_Val = newTravelCode;
              Travel.Travel_Code = newTravelCode;
              Travel.Travel_DateDup = new Date();
              //Travel.Travel_statut = 0
              Travel.Travel_version = lastversion;
              Travel.Travel_origineDup = travelCode;
              Travel.U_timestamp = null;

              TravelD.forEach((day) => {
                day.Travel_Code = newTravelCode;
                day.U_timestamp = null;
                //day.id = null;
              });

              TravelDM.forEach((dayM) => {
                dayM.Travel_Code = newTravelCode;
                dayM.U_timestamp = null;
              });
              console.log(this.TravelToCoppy);

              this.generalService
                .enregisterTable(this.TravelToCoppy)
                .subscribe((data) => {
                  this.generalService.dialogSuccess('Dupliqué', true);
                  this.generalService.dialog.closeAll();
                });
            },
            () => {
              this.generalService.dialogSuccess('Non Dupliqué', false);
            }
          );
      });
    });
  }

  //generer les circuits standards
  standardMode = false;
  genererStandardCircuit(mode: boolean) {
    this.standardMode = mode;

    if (this.standardMode) {
      this.reservation.Travel_Nature = 1;
      for (var i = 1; i < this.reservation.Travel_NbJour + 1; i++) {
        var listeRreservationD = this.generalService.sort(
          this.dsReservation.TravelD.filter((reservationD) => {
            return reservationD.TravelD_Jour == i;
          }),
          'TravelD_HDeb'
        );
        listeRreservationD.forEach((reservationD) => {
          var TravelD_TypeEvent = this.listeTypeEvennement.find(
            (TravelD_TypeEvent) => {
              return (
                TravelD_TypeEvent.TravelD_TypeEvent ==
                reservationD.TravelD_TypeEvent.toString()
              );
            }
          );
          var TravelD_Type = this.listeType.find((TravelD_TypeEvent) => {
            return (
              TravelD_TypeEvent.value == reservationD.TravelD_Type &&
              reservationD.TravelD_TypeEvent ==
                Number(TravelD_TypeEvent.TravelD_TypeEvent)
            );
          });
          reservationD.typeEvennementText = TravelD_TypeEvent
            ? TravelD_TypeEvent.text
            : '';
          reservationD.typeText = TravelD_Type ? TravelD_Type.text : '';
          // reservationD.Tiers_RS = reservationD.Tiers_code
          // reservationD.Tiers_RS = reservationD.Tiers_code
        });
        this.listeReservationDetail.push({
          liste: listeRreservationD,
        });
      }
      this.listeReservationDetail.splice(0, 1);
      console.log(this.listeReservationDetail);

      console.log(this.dsReservation);
    } else {
      this.reservation.Travel_Nature = 0;
      this.initEverything();
      this.listeReservationDetail = [];
      console.log(this.dsReservation);
    }

    if (this.mode == 2) {
      this.router.navigateByUrl('/avt/grh/reservation/-1/1');
    }
  }

  //! generation des evenements d'herbergement
  //! automatisation de la ligne Petit dejeuner apres ligne herbergement

  last_herbergement_detail;
  get_Last_Herbergement_Detail(herbergement_detail) {
    this.last_herbergement_detail = herbergement_detail;
    console.log(this.last_herbergement_detail);
  }
  generate_petit_dej_after_Hebergement(data_hebergement?) {
    var TravelD_TypeEvent = {
      TravelD_TypeEvent: 3,
      text: 'LOGISTIQUE BATOUTA',
      TravelD_TypFournisseur: '2',
    };
    if (this.listeConmponent.toArray()[this.index + 1]) {
      this.TravelD_Type = {
        text: 'LOGISTIQUE',
        value: 0,
        TravelD_TypeEvent: '3',
      };
      this.listeConmponent.toArray()[this.index + 1].dataSource.push({
        id: null,
        TravelD_Jour: this.TravelD_Jour + 1,
        Travel_Code: this.dsReservation.Travel[0].Travel_Code,
        TravelD_TypeEvent: TravelD_TypeEvent.TravelD_TypeEvent,
        typeEvennementText: TravelD_TypeEvent.text,
        typeText: this.TravelD_Type ? this.TravelD_Type.text : '',
        TravelD_Event: "DEPART DE L'HOTEL",

        TravelD_Ville: data_hebergement?.TravelD_Ville,
        Tiers_code: data_hebergement?.Tiers_code,
        TravelD_Km: 0,
        TravelD_DureeTrajet: 0,
        TravelD_NbreVoiture: '',
        Tiers_RS: 'BATOUTA',
        TravelD_Type: this.TravelD_Type.value,
        TravelD_Obs: '',
        TravelD_HDeb: '7:30',
        TravelD_HFin: '08:00',
        TravelD_Duree: 30,

        TravelD_Obs1: '',
        U_timestamp: null,
        TravelD_Modif: 0,
        TravelD_EventCode: 'RH002',
        TravelD_Pos: ++this.pos,
      });

      // this.reservationD = {};
      this.listeConmponent.toArray()[this.index + 1].dataSource =
        this.SortByHDeb_Generic(
          this.listeConmponent.toArray()[this.index + 1].dataSource
        );
      this.reglageHorair_Generic(
        this.listeConmponent.toArray()[this.index + 1].dataSource,
        this.listeConmponent.toArray()[this.index + 1].dataSource[0]
          .TravelD_HDeb
      );

      //   this.enregistrer();
      //   this.refreshList()
      setTimeout(() => {
        this.generalService.dialogSuccess(
          'La ligne PETIT DEJEUNER est générée automatiquement.',
          true,
          3000
        );
      }, 2000);
    }
  }

  generate_dinner_before_Hebergement(data_hebergement?) {
    console.log(data_hebergement);

    var TravelD_TypeEvent = {
      TravelD_TypeEvent: 2,
      text: 'Restauration Hotel',
      TravelD_TypFournisseur: '2',
    };
    this.TravelD_Type = { text: 'BUFFET', value: 10, TravelD_TypeEvent: '2' };

    this.listeConmponent.toArray()[this.index].dataSource.push({
      id: null,
      TravelD_Jour: this.TravelD_Jour,
      Travel_Code: this.dsReservation.Travel[0].Travel_Code,
      TravelD_TypeEvent: TravelD_TypeEvent.TravelD_TypeEvent,
      typeEvennementText: TravelD_TypeEvent.text,
      typeText: this.TravelD_Type ? this.TravelD_Type.text : '',
      TravelD_Event: 'DINNER',

      TravelD_Ville: data_hebergement?.TravelD_Ville,
      Tiers_code: data_hebergement?.Tiers_code,
      TravelD_Km: 0,
      TravelD_DureeTrajet: 0,
      TravelD_NbreVoiture: '',
      Tiers_RS: data_hebergement?.Tiers_RS,
      TravelD_Type: this.TravelD_Type.value,
      TravelD_Obs: '',
      TravelD_HDeb: this.ConvertisseurHoraire_Chaine_Genric(
        this.ConvertisseurHoraire_Minute_Generic(
          data_hebergement?.TravelD_HDeb
        ) - 60
      ),
      TravelD_HFin: data_hebergement.TravelD_HDeb,
      TravelD_Duree: 60,

      TravelD_Obs1: '',
      U_timestamp: null,
      TravelD_Modif: 0,
      TravelD_EventCode: 'RH001',
      TravelD_Pos: ++this.pos,
    });

    // this.reservationD = {};
    this.listeConmponent.toArray()[this.index].dataSource =
      this.SortByHDeb_Generic(
        this.listeConmponent.toArray()[this.index].dataSource
      );
    this.reglageHorair_Generic(
      this.listeConmponent.toArray()[this.index].dataSource,
      this.listeConmponent.toArray()[this.index].dataSource[0].TravelD_HDeb
    );

    //   this.enregistrer();
    //   this.refreshList()
    setTimeout(() => {
      this.generalService.dialogSuccess(
        'La ligne Dinner est générée automatiquement.',
        true,
        1000
      );
    }, 1000);
  }
  openInNewTab(link: string): void {
    const url = this.router.serializeUrl(this.router.createUrlTree([link]));
    window.open(url, '_blank');
  }
  logValue() {
    console.log(this.dsReservation);
  }
}
